PJQ.views.budget.LineItemsView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'line-items-view'),
        subTemplates: {
            invoiceHeader: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'invoice-line-items-header'),
            changeRequestHeader: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-request-line-items-header'),
            actions: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'line-items-actions')
        },
        isSubmitting: false,
        canEdit: true,
        canDelete: true,
        isAdmin: true,
        isCostCodeRequired: true,
        isCostTypeRequired: true,
        filterToPrimeContractItems: false,
        canChangeAccountingMethod: false,
        canImportBudget: false,
        accountingMethod: PJQ.constants.budget.accountingMethod.AMOUNT,
        onAccountingMethodChanged: null,
        lineItemModel: PJQ.models.BaseModel,
        enableSelection: false,
        canSendRFQ: false,
        onLineItemAdd: null,
        onLineItemChange: null,
        onLineItemDelete: null,
        onTotalsChanged: null,
        enableStoredMaterials: true,
        enableRetainage: true,
        enableTax: false,
        billedToDate: null,
        approvedChanges: null,
        showMarkup: true,
        isBudget: false,
        showBilling: false,
        showSubTotal: false,
        showGrandTotal: false,
        showRevenue: false,
        copyCostToRevenue: false
    },
    events: {
        'click .btn-add-standard': 'addStandardCostCodes',
        'click .btn-add-cost-code': 'addCostCodeClicked',
        'click .btn-view-commitment': 'viewCommitment',
        'click .btn-view-change-order': 'viewChangeOrder',
        'click .btn-import-budget': 'importBudget',
        'click .btn-import-file': 'importFile',
        'click .btn-import-contracts': 'importContracts',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-add-all-line-items': 'addAllPossibleLineItems',
        'click .btn-autofill-amounts': 'autofillAmounts',
        'click .btn-save-line-item': 'saveLineItem',
        'click .btn-delete-line-item': 'deleteLineItemClicked',
        'focus .input-dollars-full,.input-percent,.input-hours': 'selectInput',
        'change .input-progress-percent': 'minimumProgressPercent',
        'click .btn-add-from-change-requests': 'addFromChangeRequests',
        'click .btn-add-from-commitments': 'addFromCommitments',
        'click .select-cr-li': 'lineItemSelected',
        'click .btn-new-commitment': 'createCommitmentFromLineItems',
        'click .btn-existing-commitment': 'addLineItemsToCommitment',
        'click .btn-new-pcco': 'createPCCOFromLineItems',
        'click .btn-existing-pcco': 'addLineItemsToPCCO',
        'click .btn-new-cco': 'createCCOFromLineItems',
        'click .btn-existing-cco': 'addLineItemsToCCO',
        'click .btn-total-fn': 'totalButtonClicked',
        'click .btn-edit-bulk': 'bulkEditLineItems',
        'click .btn-delete-bulk': 'bulkDeleteLineItems',
        'click .select-all-line-items': 'selectAllLineItems',
        'click .btn-edit-line-item-vendor': 'editLineItemVendor',
        'click .btn-send-rfq': 'sendRFQClicked',
        'keyup .input-budgeted-hours': 'lineItemHoursChanged',
    },
    addStandardCostCodes: function (e) {
        let $btn = $(e.currentTarget),
            lineItem = this.getLineItemForInput($btn),
            subJobId = lineItem.get('subJobId'),
            title;
        if (subJobId != null) {
            title = 'Add Cost Codes To Sub Job';
        } else {
            title = 'Add Cost Codes To Project'
        }

        new PJQ.views.budget.CostCodePickerModal({
            title: title,
            pickerOptions: {
                showDisabledAsSelected: true,
                isCostCodeDisabled: _.bind(function (costCode) {
                    return null != _.find(this.costCodes.models, function (pCostCode) {
                        return (subJobId == null || pCostCode.get('subJobId') === subJobId) && pCostCode.get('code').toLowerCase() === costCode.get('code').toLowerCase();
                    })
                }, this)
            },
            onSave: _.bind(function (newCostCodes) {
                if (_.size(newCostCodes) > 0) {
                    this.costCodes.saveBulk(newCostCodes, subJobId, _.bind(function (savedCostCodes) {
                        if (savedCostCodes) {
                            if (this.options.project) {
                                this.options.project.costCodes.add(savedCostCodes);
                            }
                            this.renderLineItemsTable();
                            PJQ.notifications.notify.successNotify({
                                message: _.size(savedCostCodes).toString() + ' Company Cost Codes added to project'
                            });
                        } else {
                            // todo: error
                        }
                    }, this));
                }
            }, this)
        });
    },
    sendRFQClicked: function () {
        if (typeof this.options.onSendRFQ === 'function') {
            this.options.onSendRFQ({
                selectedIds: this.options.selectedLineItems,
                projectCommitments: this.projectCommitments
            });
        }
    },
    addCostCodeClicked: function (e) {
        let $btn = $(e.currentTarget),
            lineItem = this.getLineItemForInput($btn);
        new PJQ.views.budget.EditCostCodeModal({
            project: PJQ.app.session.project,
            onSave: _.bind(function (costCode) {
                this.costCodes.add(costCode);
                lineItem.set('costCodeId', costCode.id);
                this.renderLineItemsTable();
            }, this)
        });
    },
    beforeFirstRender: async function () {
        this.options.project = this.options.project != null ? this.options.project : PJQ.app.session.project;
        this.options.addingNewContractLineItems = [];
        this.isReceivableInvoices = this.options.lineItemModel === PJQ.models.invoicing.ReceivableInvoiceLineItem;
        this.isInvoices = this.options.lineItemModel === PJQ.models.invoicing.PayableInvoiceLineItem
            || this.isReceivableInvoices;
        this.isDirectCosts = this.options.lineItemModel === PJQ.models.directcosts.LineItem;
        this.isChangeRequests = this.options.lineItemModel === PJQ.models.changeRequests.ChangeRequestLineItem;
        this.isPCCO = this.options.lineItemModel === PJQ.models.primeContracts.ChangeOrderLineItem;
        this.isCCO = this.options.lineItemModel === PJQ.models.commitments.ChangeOrderLineItem;
        this.isCommitments = this.options.lineItemModel === PJQ.models.commitments.CommitmentLineItem;

        this.isFetched = false;
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.options.project.isERPSynced()) {
            if (this.options.lineItemModel === PJQ.models.commitments.ChangeOrderLineItem) {
                this.options.filterToCommitmentCostCodes = this.options.commitmentId > 0 && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV);
            }

            if (this.options.lineItemModel === PJQ.models.primeContracts.ChangeOrderLineItem || this.options.lineItemModel === PJQ.models.changeRequests.ChangeRequestLineItem) {
                this.options.filterToPrimeContractItems = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO);

                if (this.options.filterToPrimeContractItems && this.options.lineItemModel === PJQ.models.primeContracts.ChangeOrderLineItem) {
                    this.options.requirePrimeContractItem = true;
                }

                this.options.isCostCodeRequired = this.options.isCostTypeRequired = !(true === this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED));
            } else if (this.options.lineItemModel === PJQ.models.primeContracts.LineItem) {
                this.options.isCostCodeRequired = this.options.isCostTypeRequired = !(true === this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED));
            }
        }

        if (this.options.project.hasPermission('budget.canView')) {
            this.budget = await this.options.project.fetchBudget();
        }
        this.subJobs = await this.options.project.fetchSubJobs();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        if (this.options.enableTax) {
            this.taxCodes = await this.options.project.fetchTaxCodes();
            this.options.enableTax = _.size(this.taxCodes.models) > 0;
        }

        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.options.project && this.isChangeRequests && this.options.canEdit) {
            this.projectCommitments = new PJQ.collections.commitments.Commitments([], {
                projectId: this.options.project.id,
                withLineItems: true
            });
            await this.projectCommitments.fetch();
        }

        this.isFetched = true;
        this.render(true);
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }


        this.canAddCommitments = this.options.project.hasPermission('commitments.canAdd');
        this.canAddCommitmentChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.canAddContractChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.canAdd');
    },
    renderData: function () {
        return {
            project: PJQ.app.session.project,
            subJobs: this.subJobs,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            isInvoices: this.isInvoices,
            isDirectCosts: this.isDirectCosts,
            isChangeRequests: this.isChangeRequests,
            canApplyChangeRequestCosts: this.options.canApplyChangeRequestCosts,
            canApplyChangeRequestRevenue: this.options.canApplyChangeRequestRevenue,
            enableSelection: this.options.enableSelection,
            canSendRFQ: this.options.canSendRFQ,
            onSendRFQ: null,
            isReceivableInvoices: this.isReceivableInvoices,
            canImportBudget: this.options.canImportBudget,
            canChangeAccountingMethod: this.options.canChangeAccountingMethod,
            canEdit: this.options.canEdit,
            isBudget: this.options.isBudget,
            isFetched: this.isFetched,
            isCCO: this.isCCO,
            isPCCO: this.isPCCO,
            showRevenue: this.options.showRevenue,
            selectedLineItems: this.options.selectedLineItems,
            isCommitments: this.isCommitments,
            canAddCommitments: this.canAddCommitments,
            canAddCommitmentChangeOrders: this.canAddCommitmentChangeOrders,
            canAddContractChangeOrders: this.canAddContractChangeOrders
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.accountingMethodPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-accounting-method'),
            isIntChoices: true,
            defaultValue: this.options.accountingMethod,
            canEdit: this.options.canEdit && _.size(this.getVisibleLineItems()) === 0,
            onChange: _.bind(function (value) {
                this.options.accountingMethod = value;
                if (typeof this.options.onAccountingMethodChanged === 'function') {
                    this.options.onAccountingMethodChanged(value);
                }
                this.renderLineItemsTable();
            }, this)
        });
        this.renderActions();
        this.renderLineItemsTable();
        this.updateAccountingMethodSelector();
        this.renderTotals();
    },
    minimumProgressPercent: function (e) {
        let $input = $(e.currentTarget),
            lineItem = this.getLineItemForInput($input);
        if (lineItem != null) {
            let percent = lineItem.get('progressPercent'),
                totalProgressPercent = lineItem.get('progressPercentTotal');
            if (percent < totalProgressPercent) {
                $input.val(PJQ.helpers.formatHelpers.formatPercent(totalProgressPercent));
                lineItem.set('progressPercent', totalProgressPercent);
            }
        }
    },
    selectInput: function (e) {
        let el = $(e.currentTarget)[0];
        if (this.focusInput !== el) {
            this.focusInput = el;
            setTimeout(_.bind(function () {
                this.focusInput.select();
            }, this), 100);
        }
    },
    importBudget: function () {
        this.options.project.fetchBudget(_.bind(function (budget) {
            let newLineItems = [],
                counter = 1;
            _.each(_.sortBy(budget.lineItems.models, (lineItem) => {
                let costCode = this.costCodes.get(lineItem.get('costCodeId'));
                if (costCode != null) {
                    return costCode.get('code');
                }
                return '';
            }), function (lineItem) {
                newLineItems.push(new this.options.lineItemModel({
                    subJobId: lineItem.get('subJobId'),
                    costCodeId: lineItem.get('costCodeId'),
                    costTypeId: lineItem.get('costTypeId'),
                    amount: lineItem.get('budgetedCost'),
                    description: '',
                    number: counter,
                    accountingMethod: this.options.accountingMethod
                }));
                counter++;
            }, this);
            this.collection.reset(newLineItems);
            this.renderLineItemsTable();
        }, this));
    },
    importFile: function () {
        this.renderUploader();
    },
    importContracts: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'budgets',
                    value: 'lineitems'
                },
                {
                    endpoint: 'import',
                    value: 'contracts'
                }
            ]),
            isAPIv2: true,
        }).get().done(_.bind(function (data) {
            let filteredLineItems = _.sortBy(_.filter(data, (lineItem) => {
                return null == this.collection.findWhere({
                    costCodeId: lineItem.costCodeId,
                    costTypeId: lineItem.costTypeId
                });
            }), (lineItem) => {
                let costCode = this.costCodes.get(lineItem.costCodeId);
                if (costCode != null) {
                    return costCode.get('code');
                }
                return '';
            });
            this.collection.add(filteredLineItems);
            this.renderLineItemsTable();

            if (typeof this.options.onLineItemAdd === 'function') {
                this.options.onLineItemAdd();
            }
        }, this)).fail(_.bind(function (data) {

        }, this));
    },
    getVisibleLineItems: function () {
        return _.filter(this.collection.models, function (model) {
            return !model.get('delete');
        });
    },
    renderUploader: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'budgets'
                        },
                        {
                            endpoint: 'lineitems'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    let uploadId = file.uploadId;
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id,
                            },
                            {
                                endpoint: 'budgets'
                            },
                            {
                                endpoint: 'lineitems'
                            },
                            {
                                endpoint: 'import',
                                value: uploadId
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (result) {
                        loader.remove();
                        this.fileUploader.remove();
                        this.subJobs.add(result.subJobs);
                        this.costCodes.add(result.costCodes);
                        this.costTypes.add(result.costTypes);
                        this.collection.add(result.lineItems);
                        this.renderLineItemsTable();
                        if (typeof this.options.onLineItemAdd === 'function') {
                            this.options.onLineItemAdd();
                        }
                    }, this)).fail((err) => {
                        if (err && err.responseJSON) {
                            loader.remove();
                            let file = this.fileUploader.collection.models[0];
                            this.fileUploader.collection.remove(file);
                            this.fileUploader.render();
                            this.fileUploader.showError(err.responseJSON.message, 10000);
                        }
                    });
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
        let self = this;
        $uploader.find('.btn-download-template').off('click').on('click', self.downloadImportTemplate);
    },
    updateAccountingMethodSelector: function () {
        if (this.accountingMethodPicker != null) {
            if (!this.options.canEdit || _.size(this.getVisibleLineItems()) > 0) {
                this.accountingMethodPicker.disable();
            } else {
                this.accountingMethodPicker.enable();
            }
        }
    },
    renderTotals: function () {
        let amount = 0,
            billed = 0;
        _.each(this.collection.models.filter((lineItem) => {
            return !lineItem.get('delete');
        }), function (lineItem) {
            billed += lineItem.get('progressAmount');
            if (this.isInvoices) {
                amount += lineItem.get('progressAmount') + lineItem.get('materialsNew') - lineItem.get('workRetainage') - lineItem.get('materialRetainage') + lineItem.get('workRetainageReleased') + lineItem.get('materialRetainageReleased');
            } else if (this.options.isBudget) {
                amount += lineItem.get('budgetedCost');
            } else {
                amount += lineItem.get('amount');
            }
        }, this);

        this.$('.line-items-amount').text(PJQ.helpers.formatHelpers.formatCurrency(amount));
        if (!this.isInvoices) {
            this.$('.line-items-billed').text(PJQ.helpers.formatHelpers.formatCurrency(billed));
            this.$('.line-items-remaining').text(PJQ.helpers.formatHelpers.formatCurrency((amount - billed)));
        }

        if (typeof this.options.onTotalsChanged === 'function') {
            this.options.onTotalsChanged();
        }

        this.renderTableFooter();
    },
    getColumns: function () {
        let columns = [];
        if (this.options.enableSelection && (this.options.canApplyChangeRequestRevenue || this.options.canApplyChangeRequestCosts || this.options.canSendRFQ || this.isInvoices)) {
            columns.push({
                "title": '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-line-items" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>',
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let enable = !row.get('revenueLineItemId') || !row.get('costLineItemId');

                    if (!row.markup && !row.get('appliedMarkupId')) {
                        return ('<div class="text-align-center"><div title="' + (!enable ? 'This line item is already added to a Commitment/CO and Contract CO' : '') + '" class="pretty p-default p-smooth fs-18 m-0"><input ' + (!enable ? 'disabled' : '') + ' type="checkbox" class="select-cr-li" data-cid="' + row.cid + '"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    } else {
                        return '';
                    }
                }, this),
                "width": '4%'
            });
        }

        let fnBudgetCodeCols = () => {
            if (this.isInvoices) {
                return [
                    {
                        "columnData": "costCodeId",
                        "title": "Budget Code",
                        "titleSettings": "Budget Code",
                        "width": this.isChangeRequests ? '15%' : '20%',
                        "render": (data, type, row) => {
                            if (this.options.canEdit && row.get('lineItemId') == null) {
                                return '<select class="select-line-item form-control"></select>';
                            }

                            let costCode = this.costCodes.get(row.get('costCodeId')),
                                costType = this.costTypes.get(row.get('costTypeId'));
                            return '<div class="font-weight-bold min-wd-200p">' + (costCode ? costCode.getDisplayName() : '') + '</div>' + '<div class="text-muted fs-14">' + (costType ? costType.get('name') : '') + '</div>';
                        }
                    }];
            } else if (this.options.canEdit) {
                return [{
                    "columnData": "costCodeId",
                    "title": "Cost Code",
                    "width": this.isChangeRequests ? '15%' : '20%',
                    "render": (data, type, row) => {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && row.isNew() && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId')) && markup == null) {
                            let res = '<div class="d-flex"><select class="select-cost-code form-control"></select>';
                            if (PJQ.app.session.project.hasPermission('budget.isAdmin')) {
                                // res += `<button type="button" class="btn btn-xs btn-transparent-dark btn-add-cost-code text-info" title="New Cost Code">
                                //                 <i class="far fa-plus mr-1"></i>
                                //             </button>`

                                if ((PJQ.app.session.erpIntegration == null || (PJQ.app.session.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES) && PJQ.app.session.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PROJECT_SPECIFIC_COST_CODES)))) {
                                    res += `<div class="btn-group">
                                        <button type="button" class="btn btn-link btn-link-bold dropdown-toggle no-after" data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                            <i class="far fa-plus"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item btn-add-cost-code" title="Create a new project-specific cost code"
                                               href="javascript:void(0)">New Project Cost Code</a>
                                            <a class="dropdown-item btn-add-standard"
                                               title="Add cost codes from your company cost codes"
                                               href="javascript:void(0)">From Company Cost Codes</a>
                                        </div>
                                    </div>`;
                                } else {
                                    res += `<button type="button" class="btn btn-link btn-link-bold btn-add-standard">
                                        <i class="far fa-plus"></i>
                                    </button>`;
                                }
                            }
                            res += '</div>';
                            return res;
                        } else {
                            let costCode = this.costCodes.get(row.get('costCodeId'));
                            return costCode ? costCode.getDisplayName() : '';
                        }
                    }
                },
                    {
                        "columnData": "costTypeId",
                        "title": "Type",
                        "titleSettings": "Cost Type",
                        "width": this.isChangeRequests ? "7%" : "10%",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && row.isNew() && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId')) && markup == null) {
                                return '<select class="select-cost-type form-control"></select>';
                            } else {
                                let costType = this.costTypes.get(row.get('costTypeId'));
                                return costType ? costType.get('name') : '';
                            }
                        }
                    }];
            } else {
                return [
                    {
                        "columnData": "costCodeId",
                        "title": "Budget Code",
                        "titleSettings": "Budget Code",
                        "width": this.isChangeRequests ? '15%' : '20%',
                        "render": (data, type, row) => {
                            if (this.isInvoices && row.get('lineItemId') == null) {
                                return ''
                            }

                            let costCode = this.costCodes.get(row.get('costCodeId')),
                                costType = this.costTypes.get(row.get('costTypeId'));
                            return '<div class="font-weight-bold min-wd-200p">' + (costCode ? costCode.getDisplayName() : '') + '</div>' + '<div class="text-muted fs-14">' + (costType ? costType.get('name') : '') + '</div>';
                        }
                    }];
            }
        }

        if (this.isInvoices) {
            columns.push(...[
                {
                    "columnData": "attributes.number",
                    "title": "#",
                    "width": "50px",
                    "render": (data, type, row, opt) => {
                        let self = this;

                        return `<div class=" text-align-center ${self.options.canEdit ? '' : 'p-1'}">${(opt.row + 1).toString()}</div>`;
                    }
                },
                {
                    "columnData": "attributes.id",
                    "title": "Source",
                    "render": _.bind(function (data, type, row) {
                        let result;
                        if (row.get('commitmentId') > 0) {
                            result = '<a href="javascript:void(0)" title="' + row.get('commitmentNumber') + '" class="btn-view-commitment" data-id="' + row.get('commitmentId') + '">' + row.get('commitmentNumber') + '</a>';
                        } else if (row.get('primeContractId') > 0) {
                            result = '<a href="javascript:void(0)" title="' + row.get('primeContractNumber') + '" class="btn-view-prime-contract" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                        } else if (row.get('changeOrderId') > 0) {
                            result = '<a href="javascript:void(0)" title="' + row.get('changeOrderNumber') + '" class="btn-view-change-order" data-id="' + row.get('changeOrderId') + '">' + row.get('changeOrderNumber') + '</a>';
                        } else {
                            result = '';
                        }
                        return '<div class="min-wd-120p">' + result + '</div>';
                    }, this)
                },
                {
                    "columnData": "subJobId",
                    "title": "Sub Job",
                    "visible": _.size(this.subJobs.models) > 0,
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        let subJob = this.subJobs.get(row.get('subJobId'));
                        return '<div class="min-wd-120p">' + (subJob ? subJob.get('name') : '') + '</div>';
                    }, this)
                },
                ...fnBudgetCodeCols(),
                {
                    "columnData": "description",
                    "data": "attributes.description",
                    "title": "Description",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-200p">' + row.get('description') + '</div>';
                    }, this)
                },
                {
                    "columnData": "committedAmount",
                    "data": "",
                    "title": "Scheduled Value",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-80p">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('committedAmount')) + '</div>'
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('committedAmount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "columnData": "progressAmountTotal",
                    "data": "attributes.progressAmountTotal",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-80p">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmountTotal')) + '</div>';
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('progressAmountTotal');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "columnData": "progressPercentTotal",
                    "data": "attributes.progressPercentTotal",
                    "title": "%",
                    "format": "percent",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-80p">' + PJQ.helpers.formatHelpers.formatPercent(row.get('progressPercentTotal')) + '</div>';
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        if (_.size(data) > 0) {
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('progressPercentTotal');
                            });
                            amt = amt / _.size(data)
                        }
                        return PJQ.helpers.formatHelpers.formatPercent(amt);
                    }
                },
                {
                    "columnData": "progressAmount",
                    "data": "attributes.progressAmount",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control wd-120p text-align-right input-dollars-full input-progress-amount" data-p-bind="progressAmount" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount')) + '" data-p-bind="progressAmount" placeholder="0.00">';
                        } else {
                            return '<div class="text-align-center pr-1 wd-80p">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount')) + '</div>';
                        }
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('progressAmount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "columnData": "progressPercent",
                    "data": "attributes.progressPercent",
                    "title": "%",
                    "format": "percent",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text"\n class="form-control wd-80p text-align-right input-percent input-progress-percent" data-p-bind="progressPercent" placeholder="0" value="' + row.get('progressPercent') + '"/>'
                        } else {
                            result = PJQ.helpers.formatHelpers.formatPercent(row.get('progressPercent'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        if (_.size(data) > 0) {
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('progressPercent');
                            });
                            amt = amt / _.size(data)
                        }
                        return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                    }
                }]);
            if (this.options.enableStoredMaterials) {
                columns.push(...[{
                    "columnData": "materialsNew",
                    "data": "attributes.materialsNew",
                    "title": "New",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text" class="form-control wd-80p text-align-right input-dollars-full input-materials-new" data-p-bind="materialsNew" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('materialsNew')) + '" data-p-bind="materialsNew" placeholder="0.00">';
                        } else {
                            result = PJQ.helpers.formatHelpers.formatCurrency(row.get('materialsNew'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('materialsNew');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                    {
                        "columnData": "materialsStored",
                        "data": "attributes.materialsStored",
                        "title": "Stored",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return ''
                            }

                            return '<div class="wd-80p label-materials-stored">' + PJQ.helpers.formatHelpers.formatCurrency(Math.max(0, row.getMaterialsStored(this.model))) + '</div>'
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('materialsStored');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    }]);
            }

            if (this.options.enableTax) {
                columns.push({
                    "columnData": "taxAmount",
                    "data": "attributes.taxAmount",
                    "width": "10%",
                    "title": "Tax",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (this.isInvoices && row.get('lineItemId') == null) {
                            return ''
                        }

                        let taxAmount = PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                        if (this.options.canEdit) {
                            return '<span class="label-tax-amount">' + taxAmount + '</span>';
                        }
                        return taxAmount;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('taxAmount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                });
            }

            columns.push(...[{
                "columnData": "",
                "data": "",
                "title": "Total Completed and Stored",
                "format": "money",
                "orderable": false,
                "searchable": false,
                "className": "text-align-center",
                "render": _.bind(function (data, type, row) {
                    if (row.get('lineItemId') == null) {
                        return ''
                    }

                    return '<div class="wd-80p label-total-completed">' + PJQ.helpers.formatHelpers.formatCurrency(row.getTotalCompleteAndStored(this.model)) + '</div>'
                }, this),
                "renderFooter": _.bind(function (data) {
                    let amt = 0;
                    _.each(data, function (lineItem) {
                        amt += lineItem.getTotalCompleteAndStored(this.model);
                    });
                    return PJQ.helpers.formatHelpers.formatCurrency(amt);
                }, this)
            },
                {
                    "columnData": "",
                    "data": "",
                    "title": "Balance To Finish",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }
                        return '<div class="wd-80p label-balance-to-finish">' + PJQ.helpers.formatHelpers.formatCurrency(row.getBalanceToFinish(this.model)) + '</div>'
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.getBalanceToFinish(this.model);
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                }]);
            if (this.options.enableRetainage) {
                columns.push(...[{
                    "columnData": "",
                    "data": "attributes.workRetainage",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }

                        let result;
                        if (this.options.canEdit && !this.options.isSubmitting) {
                            result = '<input type="text" class="form-control wd-120p text-align-right input-dollars-full input-work-retainage-amount" data-p-bind="workRetainage" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainage')) + '" data-p-bind="workRetainage" placeholder="0.00">';
                        } else {
                            result = PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainage'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('workRetainage');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                    {
                        "columnData": "",
                        "data": "attributes.workRetainagePercent",
                        "title": "%",
                        "format": "percent",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit && !this.options.isSubmitting) {
                                result = '<input type="text"\n class="form-control wd-80p text-align-right input-percent input-work-retainage-percent" data-p-bind="workRetainagePercent" placeholder="0" value="' + (row.get('workRetainagePercent')) + '"/>'
                            } else {
                                result = PJQ.helpers.formatHelpers.formatPercent(row.get('workRetainagePercent'));
                            }
                            return result
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            if (_.size(data) > 0) {
                                _.each(data, function (lineItem) {
                                    amt += lineItem.get('workRetainagePercent');
                                });
                                amt = amt / _.size(data)
                            }
                            return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                        }
                    }]);
                if (this.options.enableStoredMaterials) {
                    columns.push(...[{
                        "columnData": "",
                        "data": "attributes.materialRetainage",
                        "title": "$",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit && !this.options.isSubmitting) {
                                result = '<input type="text" class="form-control wd-120p text-align-right input-dollars-full input-material-retainage-amount" data-p-bind="materialRetainage" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainage')) + '" data-p-bind="materialRetainage" placeholder="0.00">';
                            } else {
                                result = PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainage'));
                            }
                            return result
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('materialRetainage');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    },
                        {
                            "columnData": "",
                            "data": "attributes.materialRetainagePercent",
                            "title": "%",
                            "format": "percent",
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": _.bind(function (data, type, row) {
                                if (row.get('lineItemId') == null) {
                                    return '';
                                }

                                let result;
                                if (this.options.canEdit && !this.options.isSubmitting) {
                                    result = '<input type="text"\n class="form-control wd-80p text-align-right input-percent wd-100 input-material-retainage-percent" data-p-bind="materialRetainagePercent" placeholder="0" value="' + (row.get('materialRetainagePercent')) + '"/>'
                                } else {
                                    result = PJQ.helpers.formatHelpers.formatPercent(row.get('materialRetainagePercent'));
                                }
                                return result
                            }, this),
                            "renderFooter": function (data) {
                                let amt = 0;
                                if (_.size(data) > 0) {
                                    _.each(data, function (lineItem) {
                                        amt += lineItem.get('materialRetainagePercent');
                                    });
                                    amt = amt / _.size(data)
                                }
                                return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                            }
                        }]);
                }
                columns.push(...[{
                    "columnData": "",
                    "data": "attributes.workRetainageReleased",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text" class="form-control wd-120p text-align-right input-dollars-full input-work-retainage-released-amount" data-p-bind="workRetainageReleased" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainageReleased')) + '" data-p-bind="workRetainageReleased" placeholder="0.00">';
                        } else {
                            result = PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainageReleased'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('workRetainageReleased');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                    {
                        "columnData": "",
                        "data": "attributes.workRetainageReleasedPercent",
                        "title": "%",
                        "format": "percent",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit) {
                                result = '<input type="text"\n class="form-control wd-80p text-align-right input-percent wd-100 input-work-retainage-released-percent" data-p-bind="workRetainageReleasedPercent" placeholder="0" value="' + row.get('workRetainageReleasedPercent') + '"/>'
                            } else {
                                result = PJQ.helpers.formatHelpers.formatPercent(row.get('workRetainageReleasedPercent'));
                            }
                            return result;
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            if (_.size(data) > 0) {
                                _.each(data, function (lineItem) {
                                    amt += lineItem.get('workRetainageReleasedPercent');
                                });
                                amt = amt / _.size(data)
                            }
                            return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                        }
                    }]);
                if (this.options.enableStoredMaterials) {
                    columns.push(...[{
                        "columnData": "",
                        "data": "attributes.materialRetainageReleased",
                        "title": "$",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit) {
                                result = '<input type="text" class="form-control wd-120p text-align-right input-dollars-full input-material-retainage-released-amount" data-p-bind="materialRetainageReleased" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainageReleased')) + '" data-p-bind="materialRetainageReleased" placeholder="0.00">';
                            } else {
                                result = PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainageReleased'));
                            }
                            return result;
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('materialRetainageReleased');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    },
                        {
                            "columnData": "",
                            "data": "attributes.materialRetainageReleasedPercent",
                            "title": "%",
                            "format": "percent",
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": _.bind(function (data, type, row) {
                                if (row.get('lineItemId') == null) {
                                    return '';
                                }

                                let result;
                                if (this.options.canEdit) {
                                    result = '<input type="text"\n class="form-control wd-80p text-align-right input-percent wd-100 input-material-retainage-released-percent" data-p-bind="materialRetainageReleasedPercent" placeholder="0" value="' + row.get('materialRetainageReleasedPercent') + '"/>'
                                } else {
                                    result = PJQ.helpers.formatHelpers.formatPercent(row.get('materialRetainageReleasedPercent'));
                                }
                                return result;
                            }, this),
                            "renderFooter": function (data) {
                                let amt = 0;
                                if (_.size(data) > 0) {
                                    _.each(data, function (lineItem) {
                                        amt += lineItem.get('materialRetainageReleasedPercent');
                                    });
                                    amt = amt / _.size(data)
                                }
                                return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                            }
                        }]);
                }
                columns.push({
                    "columnData": "",
                    "data": "attributes.workRetainageTotal",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }
                        return '<div class="wd-80p label-work-retainage-remaining">' + PJQ.helpers.formatHelpers.formatCurrency(row.getWorkRetainageRemaining(this.model)) + '</div>';
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.getWorkRetainageRemaining(this.model);
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                });
                if (this.options.enableStoredMaterials) {
                    columns.push({
                        "columnData": "",
                        "data": "attributes.materialRetainageTotal",
                        "title": "$",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }
                            return '<div class="wd-80p label-material-retainage-remaining">' + PJQ.helpers.formatHelpers.formatCurrency(row.getMaterialRetainageRemaining(this.model)) + '</div>';
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.getMaterialRetainageRemaining(this.model);
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    });
                }
            }
        } else {
            columns.push(...[
                {
                    "columnData": "attributes.number",
                    "title": "#",
                    "width": `5%`,
                    "render": _.bind(function (data, type, row, opt) {
                        let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null,
                            html = '<div class=" text-align-center mr-1' + (this.options.canEdit ? '' : 'p-1') + '">';
                        if (row.get('changeRequestLineItemId')) {
                            html += '<i class="fa-solid fa-asterisk text-primary mr-2" title="This line item was created from a change request line item"></i>'
                        }

                        if (isAppliedLineItem) {
                            html += '<i class="fa-solid fa-arrow-up text-primary mr-2" title="This line item was created from a markup"></i>'
                        }

                        html += (opt.row + 1).toString();

                        return `${html}</div>`;
                    }, this)
                },
                {
                    "columnData": "attributes",
                    "title": "Contract Item",
                    "visible": this.options.filterToPrimeContractItems,
                    "render": _.bind(function (data, type, row) {
                        if (this.options.canEdit && (!this.isChangeRequests || (this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId')))) {
                            if (this.options.addingNewContractLineItems.includes(row.cid)) {
                                return '<input type="text" class="form-control input-contract-item" placeholder="Type Contract Item Name..." value="' + row.get('description') + '" data-p-bind="description">'
                            } else {
                                return '<select class="select-prime-contract-item form-control" ></select>';
                            }
                        } else {
                            return row.get('description');
                        }
                    }, this)
                },
                {
                    "columnData": "attributes",
                    "title": "Commitment Line Item",
                    "width": '10%',
                    "visible": this.isCCO && PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.RELATE_CCO_LINE_TO_COMMITMENT_LINE) === true,
                    "render": _.bind(function (data, type, row) {
                        let commitmentLineItemId = row.get('commitmentLineItemId'),
                            commitmentLineItem = commitmentLineItemId > 0 ? this.options.commitment?.lineItems.findWhere({id: commitmentLineItemId}) : null;

                        if (this.options.canEdit) {
                            return '<select class="form-control select-commitment-line"></select>';
                        } else {
                            if (commitmentLineItem != null) {
                                let costCode = this.costCodes.get(commitmentLineItem.get('costCodeId')),
                                    costType = this.costTypes.get(commitmentLineItem.get('costTypeId'));

                                return `<span class="font-weight-bold">${costCode.get('name')} - ${costType.get('name')}</span> | <span class="fs-12">${PJQ.helpers.formatHelpers.formatCurrency(commitmentLineItem.get('totalAmount'))}</span>`
                            } else {
                                return '';
                            }
                        }
                    }, this)
                },
                {
                    "columnData": "subJobId",
                    "title": "Sub Job",
                    "visible": _.size(this.subJobs.models) > 0,
                    "width": this.isChangeRequests ? "10%" : "15%",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && row.isNew() && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId'))) && markup == null) {
                            return '<select class="select-sub-job form-control"></select>';
                        } else {
                            let subJob = this.subJobs.get(row.get('subJobId'));
                            return subJob ? (subJob.get('code') + ' - ' + subJob.get('name')) : '';
                        }
                    }, this)
                },
                ...fnBudgetCodeCols()]);

            if (this.isChangeRequests) {
                if (this.options.showRevenue) {
                    columns.push({
                        "columnData": "pccoId",
                        "title": "Contract CO",
                        "width": "140px",
                        "visible": this.isChangeRequests,
                        "render": _.bind(function (data, type, row) {
                            let pccoId = row.get('pccoId'),
                                html = '';

                            if (row.get('revenueLineItemId') > 0) {
                                html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a contract change order line item"></i>'
                            }

                            if (row.get('revenueLineItemId') > 0 && pccoId > 0) {
                                if (pccoId > 0) {
                                    html += '<div class="wd-150p"><a class="btn-view-change-order" href="javascript:void(0)" data-id="' + pccoId + '" data-type="pcco">' + row.get('pccoNumber') + '</a></div>';
                                }
                            }
                            return '<div class="d-flex">' + html + '</div>';
                        }, this)
                    });
                }

                columns.push(...[
                    {
                        "columnData": "vendor",
                        "title": "Company",
                        "width": "140px",
                        "visible": this.isChangeRequests,
                        "render": _.bind(function (data, type, row) {
                            let vendor = row.get('vendor') ?? null,
                                html = "",
                                markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && markup == null) {
                                html += '<select class="form-control select-vendor"></select>';
                            } else if (vendor != null) {
                                html += PJQ.helpers.contacts.getContactAnchor({contact: vendor, useCompanyName: true});
                            } else {
                                html += '<div class="font-weight-medium">Not Assigned</div>';
                            }

                            return "<div class='d-flex align-items-center'>" + html + "</div>"
                        }, this)
                    },
                    {
                        "columnData": "commitmentId",
                        "title": "Commitment",
                        "width": "140px",
                        "visible": this.isChangeRequests,
                        "render": (data, type, row) => {
                            let commitmentId = row.get('commitmentId'),
                                ccoId = row.get('ccoId'),
                                html = '',
                                markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});

                            if (row.get('costLineItemId') > 0) {
                                html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a committed cost line item"></i>'
                            }

                            if (row.get('costLineItemId') > 0 || !this.options.canEdit || markup != null) {
                                if (commitmentId > 0) {
                                    html += '<div class="wd-150p"><a class="btn-view-commitment" href="javascript:void(0)" data-id="' + commitmentId + '">' + row.get('commitmentNumber') + '</a></div>';
                                } else if (ccoId > 0) {
                                    html += '<div class="wd-150p"><a class="btn-view-change-order" href="javascript:void(0)" data-id="' + ccoId + '" data-type="cco">' + row.get('ccoNumber') + '</a></div>';
                                }
                            } else if (this.options.canEdit) {
                                html += '<select class="form-control select-commitment"></select>';
                            }
                            return '<div class="d-flex">' + html + '</div>';
                        }
                    }
                ]);
            }

            columns.push(...[
                {
                    "columnData": "description",
                    "visible": !this.options.filterToPrimeContractItems,
                    "data": "attributes.description",
                    "width": this.isChangeRequests && this.options.canApplyChangeRequestRevenue ? "20%" : null,
                    "title": "Description",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && markup == null) {
                            return '<input type="text" class="form-control input-description" maxlength="256" value="' + row.get('description').replace(/"/g, '&quot;') + '" data-p-bind="description">';
                        } else {
                            return row.get('description');
                        }
                    }, this)
                }
            ]);

            if (this.options.isBudget) {
                columns.push({
                    "data": "attributes.budgetedHours",
                    "width": "120px",
                    "title": "Hours",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": (data, type, row) => {
                        let hrs = row.get('budgetedHours');
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours input-budgeted-hours" value="' + hrs / 60 + '" data-type="budgetedHours" placeholder="0">';
                        }
                        return hrs;
                    }
                },);
            }

            if ((this.options.showMarkup !== false || this.options.canEdit) && this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                columns.push(...[
                    {
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "width": "5%",
                        "title": "Quantity",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                                return '<input type="text" class="form-control input-decimal input-quantity" value="' + row.get('quantity') + '" data-p-bind="quantity" placeholder="0">';
                            } else {
                                return row.get('quantity');
                            }
                        }
                    },
                    {
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "title": "Unit",
                        "width": "5%",
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                                return '<select class="select-unit-type form-control"></select>';
                            } else {
                                let unitOfMeasure = this.unitsOfMeasure.get(row.get('unitId'));
                                return unitOfMeasure ? unitOfMeasure.get('name') : '';
                            }
                        }
                    },
                    {
                        "columnData": "unitPrice",
                        "data": "attributes.unitPrice",
                        "width": "10%",
                        "title": "Unit Price",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                                return '<input type="text" class="form-control text-align-right input-dollars-full input-unit-price" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice')) + '" data-p-bind="unitPrice" placeholder="0.00">';
                            } else {
                                return '<span class="label-unit-price">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice')) + '</span>';
                            }
                        }
                    }
                ]);
            } else if (this.options.showMarkup !== false || this.options.canEdit) {
                columns.push({
                    "columnData": "amount",
                    "data": "attributes.amount",
                    "width": "10%",
                    "title": this.isChangeRequests ? "Cost" : "Amount",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && (!this.isChangeRequests || (!row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                            if (this.options.accountingMethod === PJQ.constants.budget.accountingMethod.AMOUNT) {
                                if (this.options.isBudget) {
                                    return '<input type="text" class="form-control text-align-right input-dollars-full input-amount" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('budgetedCost')) + '" data-p-bind="budgetedCost" placeholder="0.00">';
                                } else {
                                    return '<input type="text" class="form-control text-align-right input-dollars-full input-amount" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('amount')) + '" data-p-bind="amount" placeholder="0.00">';
                                }
                            }
                            return '<span class="label-amount">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('amount')) + '</span>';
                        }

                        return '<span class="label-amount">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('amount')) + '</span>';
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            if (this.options.isBudget) {
                                amt += lineItem.get('budgetedCost')
                            } else {
                                amt += lineItem.get('amount')
                            }
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                });
            }

            if (this.isChangeRequests && this.options.showRevenue) {
                columns.push({
                    "columnData": "revenue",
                    "data": "attributes.revenue",
                    "width": "10%",
                    "title": "Revenue",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && !row.get('revenueLineItemId') && markup == null) {
                            return '<input type="text" class="form-control text-align-right input-dollars-full input-revenue" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue')) + '" data-p-bind="revenue" placeholder="0.00">';
                        }

                        return '<span class="label-revenue">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue')) + '</span>';
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('revenue');
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                });
            }

            if (!this.options.isBudget && !this.isDirectCosts) {
                if (this.options.financialMarkups != null && this.options.showMarkup) {
                    _.each(this.options.financialMarkups.models, (markup) => {
                        if (markup.get('isVertical') || markup.get('delete') || markup.get('void') || (markup.get('appliedCostCodeId') && markup.get('appliedCostTypeId'))) {
                            return;
                        }

                        columns.push({
                            "columnData": "markupAmount",
                            "data": "attributes.markupAmount",
                            "title": markup.get('name') + ' (' + PJQ.helpers.formatHelpers.formatPercent(markup.get('percent') / 100) + ')',
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": (data, type, row) => {
                                let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null,
                                    amt = row.getMarkupAmount(this.options.financialMarkups, {
                                        cid: markup.cid,
                                        isAppliedLineItem: isAppliedLineItem
                                    });
                                return '<span class="label-markup-amount-' + markup.cid + '">' + PJQ.helpers.formatHelpers.formatCurrency(amt) + '</span>';
                            },
                            "renderFooter": (data) => {
                                let amt = 0;

                                _.each(data, (lineItem) => {
                                    let isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;
                                    amt += lineItem.getMarkupAmount(this.options.financialMarkups, {
                                        cid: markup.cid,
                                        isAppliedLineItem: isAppliedLineItem
                                    });
                                });
                                return PJQ.helpers.formatHelpers.formatCurrency(amt);
                            }
                        });
                    });
                }

                if (this.options.enableTax) {
                    columns.push(...[{
                        "columnData": "taxCode",
                        "data": "attributes.taxCodeId",
                        "width": "8%",
                        "title": "Tax Code",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null;

                            if (this.options.canEdit && !isAppliedLineItem) {
                                return '<div class="d-flex"><select class="select-tax-code form-control"></select></div>';
                            }

                            let taxCode = this.taxCodes.get(row.get('taxCodeId'));
                            if (taxCode != null) {
                                return taxCode.get('code') + ' (' + PJQ.helpers.formatHelpers.formatPercent(taxCode.get('rate') / 100) + ')'
                            }
                            return 'N/A';
                        },
                        "renderFooter": function (data) {
                            return '';
                        }
                    }, {
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "width": "10%",
                        "title": "Tax",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            let taxAmount = PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                            if (this.options.canEdit) {
                                return '<span class="label-tax-amount">' + taxAmount + '</span>';
                            }
                            return taxAmount;
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('taxAmount');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    }]);
                }

                if (!this.isChangeRequests && this.options.showBilling) {
                    columns.push(...[
                        {
                            "columnData": "billedToDate",
                            "data": "attributes.billedToDate",
                            "width": "10%",
                            "title": "Billed to Date",
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount'));
                            }, this),
                            "renderFooter": function (data) {
                                let amt = 0;
                                _.each(data, function (lineItem) {
                                    amt += lineItem.get('progressAmount');
                                });
                                return PJQ.helpers.formatHelpers.formatCurrency(amt);
                            }
                        }]);
                }

                columns.push({
                    "columnData": "subTotal",
                    "data": "attributes.amount",
                    "title": "Subtotal",
                    "orderable": false,
                    "searchable": false,
                    "width": "150px",
                    "className": "text-align-center",
                    "render": (data, type, row) => {
                        let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null,
                            subtotal = PJQ.helpers.formatHelpers.formatCurrency(row.getSubTotal(this.options.financialMarkups, {
                                costs: this.isChangeRequests && !this.options.showRevenue,
                                isAppliedLineItem: isAppliedLineItem,
                                lineItems: this.collection
                            }));
                        if (this.options.canEdit) {
                            return '<span class="label-subtotal">' + subtotal + '</span>';
                        }
                        return subtotal;
                    },
                    "renderFooter": (data) => {
                        let amt = 0;
                        _.each(data, (lineItem) => {
                            let isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

                            amt += lineItem.getSubTotal(this.options.financialMarkups, {
                                costs: this.isChangeRequests && !this.options.showRevenue,
                                isAppliedLineItem: isAppliedLineItem,
                                lineItems: this.collection
                            });
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                });
            }
        }
        if (this.options.canEdit) {
            columns.push({
                data: "id",
                title: "",
                orderable: false,
                searchable: false,
                width: 50,
                className: 'text-align-center',
                render: _.bind(function (data, type, row) {
                    let html = '<div class="show-on-row-hover">',
                        isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null
                    if (this.options.canDelete && !isAppliedLineItem && (!this.isChangeRequests || (!row.get('revenueLineItemId') && !row.get('costLineItemId')) || row.isNew())) {
                        html += '<button type="button" class="btn btn-danger btn-delete-line-item ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }
        return columns;
    },
    lineItemHoursChanged: function (e) {
        let $input = $(e.currentTarget),
            lineItem = this.getLineItemForInput($input);
        lineItem.set('budgetedHours', Math.ceil(parseFloat($input.val()) * 60));
    },
    renderLineItemsTable: function () {
        this.data = _.sortBy(_.filter(this.collection.models, (model) => {
            return !model.get('delete');
        }), (model) => {
            return model.get('appliedMarkupId') > 0 ? model.id + 100000 : model.id;
        });
        let $dataTable = this.$('.line-items-table')
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: $dataTable,
            data: this.data,
            autoWidth: false,
            fixedHeader: {
                header: false,
                footer: false
            },
            hasFooter: true,
            extraClasses: this.isInvoices ? 'table-invoice-line-items' : '',
            isHideSearch: true,
            paging: false,
            order: [],
            language: {
                emptyTable: this.options.canEdit ? 'Click "Add Line Item" to create a new Line item' : 'No line items have been added yet'
            },
            columns: this.getColumns(),
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
                if (this.isInvoices) {
                    this.renderSubTemplate(true, this.options.subTemplates.invoiceHeader, this.$('thead').first(), {
                        subJobs: this.subJobs,
                        enableStoredMaterials: this.options.enableStoredMaterials,
                        enableRetainage: this.options.enableRetainage,
                        enableTax: this.options.enableTax,
                        canEdit: this.options.canEdit,
                        enableSelection: this.options.enableSelection
                    }, {
                        prepend: true
                    });
                } else if (this.isChangeRequests && this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                    this.renderSubTemplate(true, this.options.subTemplates.changeRequestHeader, this.$('thead').first(), {
                        subJobs: this.subJobs,
                        enableSelection: this.options.enableSelection,
                        canEdit: this.options.canEdit,
                        accountingMethod: this.options.accountingMethod
                    }, {
                        prepend: true
                    });
                }
                this.renderTableFooter(this.data);
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteLineItem(row);
                        }, this),
                        isShown: _.bind(function (row) {
                            this.options.canEdit
                        }, this),
                    }
                ]
            },
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    totalButtonClicked: function (e) {
        let $btn = $(e.currentTarget),
            fnName = $btn.data('fn'),
            fn = this.options[fnName];
        if (typeof fn === 'function') {
            fn();
        }
    },
    renderTableFooter: function () {
        if (this.dataTable && this.data) {
            let $footer = this.$('tfoot').first(),
                visibleCols = _.filter(this.getColumns(), function (column) {
                    return column.visible !== false;
                });

            $footer.find('tr').remove();
            // _.each(visibleCols, function (column, index) {
            //     if (typeof column.renderFooter === 'function') {
            //         let $footerCol = $footer.find('th').eq(index);
            //         $footerCol.html('<div class="text-align-center">' + column.renderFooter(this.data) + '</div>');
            //     }
            // }, this);

            let totalRows = [],
                lineItems = this.collection.models.filter((lineItem) => {
                    return !lineItem.get('delete');
                });
            if (this.options.showSubTotal) {
                let sTotal = 0;
                _.each(lineItems, (lineItem) => {
                    let isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

                    sTotal += lineItem.getSubTotal(this.options.financialMarkups, {
                        costs: this.isChangeRequests && !this.options.showRevenue,
                        isAppliedLineItem: isAppliedLineItem,
                        lineItems: this.collection
                    });
                });
                totalRows.push({
                    label: 'Subtotal',
                    amount: sTotal
                });
            }

            if (this.options.financialMarkups != null && this.options.showMarkup) {
                let markups = this.options.financialMarkups.getMarkups(lineItems);
                _.each(_.sortBy(_.filter(markups, (markup) => {
                    return markup.isVertical;
                }), (markup) => {
                    return markup.sortOrder;
                }), (vMarkup) => {
                    totalRows.push({
                        label: vMarkup.name + ' (' + PJQ.helpers.formatHelpers.formatPercent(vMarkup.model.get('percent') / 100) + ')',
                        amount: vMarkup.amount
                    });
                });
            }

            if (this.isInvoices) {
                if (this.options.enableRetainage) {
                    let rtTotal = 0,
                        rrTotal = 0;
                    _.each(lineItems, (lineItem) => {
                        rtTotal += lineItem.getRetainage();
                        rrTotal += lineItem.getRetainageReleased();
                    });

                    if (rtTotal > 0) {
                        totalRows.push({
                            label: 'Retainage',
                            amount: -rtTotal,
                            extraClasses: 'text-danger'
                        });
                    }

                    if (rrTotal > 0) {
                        totalRows.push({
                            label: 'Retainage Released',
                            amount: rrTotal
                        });
                    }
                }
            }

            if (this.options.enableTax) {
                let tTotal = 0;
                _.each(lineItems, (lineItem) => {
                    tTotal += lineItem.getTaxAmount();
                });
                totalRows.push({
                    label: 'Tax',
                    amount: tTotal
                });
            }

            let grandTotal = 0;
            if (this.options.showGrandTotal) {
                _.each(lineItems, (lineItem) => {
                    grandTotal += lineItem.getGrandTotal(this.options.financialMarkups, {
                        totalMarkups: true,
                        costs: this.isChangeRequests && !this.options.showRevenue
                    });
                });
            }
            if (this.options.approvedChanges != null) {
                if (this.options.showGrandTotal) {
                    totalRows.push({
                        label: 'Original Contract',
                        amount: grandTotal
                    });
                }

                totalRows.push({
                    label: 'Approved Changes',
                    amount: this.options.approvedChanges,
                    clickFn: typeof this.options.onApprovedChangesClicked === 'function' ? 'onApprovedChangesClicked' : null
                });

                if (this.options.showGrandTotal) {
                    totalRows.push({
                        label: 'Contract Total',
                        amount: grandTotal + this.options.approvedChanges,
                        bold: true
                    });
                }
            } else if (this.options.showGrandTotal) {
                totalRows.push({
                    bold: true,
                    label: 'Grand Total',
                    amount: grandTotal
                });
            }

            if (this.options.billedToDate != null) {
                let billed = null;
                if (typeof this.options.billedToDate === 'function') {
                    billed = this.options.billedToDate();
                } else if (typeof this.options.billedToDate === 'number') {
                    billed = this.options.billedToDate;
                }
                if (billed != null) {
                    totalRows.push({
                        label: 'Billed to Date',
                        amount: billed,
                        clickFn: typeof this.options.onBilledToDateClicked === 'function' ? 'onBilledToDateClicked' : null
                    });
                }
            }

            _.each(totalRows, (item) => {
                if (_.size(item.label) === 0) {
                    return;
                }

                let $totalRow = $('<tr class="total-row"></tr>'),
                    colOffset = this.options.canEdit ? 2 : 1;
                $totalRow.append('<th class="text-align-right" colspan="' + (_.size(visibleCols) - colOffset).toString() + '"><span class="pr-2 ' + (item.bold ? 'font-weight-bold' : 'font-weight-medium') + ' fs-15">' + item.label + ':</span></th>');

                let txt = '';
                if (_.size(item.clickFn) > 0) {
                    txt = '<a href="javascript:void(0)" data-fn="' + item.clickFn + '" class="btn-total-fn ' + (item.bold ? 'font-weight-bold' : 'font-weight-normal') + ' ' + item.extraClasses + '">' + PJQ.helpers.formatHelpers.formatCurrency(item.amount) + '</a>';
                } else {
                    txt = '<span class="' + (item.bold ? 'font-weight-bold' : 'font-weight-normal') + ' ' + item.extraClasses + '">' + PJQ.helpers.formatHelpers.formatCurrency(item.amount) + '</span>';
                }

                $totalRow.append('<th class="text-align-center' + (colOffset > 1 ? ' border-right-0' : '') + '">' + txt + '</th>');
                if (colOffset > 1) {
                    $totalRow.append('<th class="border-left-0"></th>');
                }

                $footer.append($totalRow);
            });
        }
    },
    updateCommitmentForChangeRequestLineItem: function (lineItem, commitment) {
        if (!(lineItem.id > 0) && commitment != null && !(lineItem.get('costCodeId') > 0)) {
            let budgetCodes = _.uniq(_.map(commitment.lineItems.models, (lineItem) => {
                return lineItem.get('costCodeId') + '|' + lineItem.get('costTypeId');
            }));
            if (_.size(budgetCodes) === 1) {
                let bcSplit = budgetCodes[0].split('|'),
                    costCodeId = parseInt(bcSplit[0]),
                    costTypeId = parseInt(bcSplit[1]);
                lineItem.set({
                    costCodeId: costCodeId,
                    costTypeId: costTypeId
                })
            }
        }

        lineItem.set({
            vendor: commitment?.contractedContact?.toJSON(),
            vendorId: commitment?.contractedContact?.id,
            commitmentId: commitment?.id,
            commitmentNumber: commitment?.get('number')
        });

        lineItem.vendor = commitment?.contractedContact;
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-hours'), 1);

        this.addListeners();
        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$el, this.collection, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'cid',
                useDecimalPercentFields: true,
                watchElements: [
                    'input'
                ]
            });
        }

        if (this.isCCO && PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.RELATE_CCO_LINE_TO_COMMITMENT_LINE) === true) {
            let fnCommitmentLineToChoice = (lineItem) => {
                let costCode = this.costCodes.get(lineItem.get('costCodeId')),
                    costType = this.costTypes.get(lineItem.get('costTypeId'));
                return {
                    id: lineItem.id,
                    name: `<span class="font-weight-bold">${costCode.get('name')} - ${costType.get('name')}</span> | <span class="fs-12">${PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('totalAmount'))}</span>`
                };
            };
            this.commitmentLinePickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-commitment-line',
                valueAttribute: 'commitmentLineItemId',
                selectPickerOptions: {
                    isBlockSubtext: true,
                    size: 5,
                    choices: (model) => {
                        if (model.get('costCodeId') > 0) {
                            let suggested = [],
                                others = [];
                            _.each(this.options.commitment.lineItems.models, (lineItem) => {
                                if (lineItem.get('costCodeId') === model.get('costCodeId')) {
                                    suggested.push(lineItem);
                                } else {
                                    others.push(lineItem);
                                }
                            });
                            if (_.size(suggested) > 0) {
                                return [{
                                    name: 'Suggested',
                                    choices: _.map(suggested, fnCommitmentLineToChoice)
                                }, {
                                    name: '',
                                    choices: _.map(others, fnCommitmentLineToChoice)
                                }];
                            }
                        }
                        return _.map(this.options.commitment.lineItems.models, fnCommitmentLineToChoice);
                    }
                },
                onChange: (model, value) => {
                    model.set('commitmentLineItemId', value);
                }
            });
        }

        if (this.isChangeRequests && this.options.canEdit) {
            let fnCommitmentToChoice = (commitment) => {
                return {
                    id: commitment.id,
                    name: '<strong>' + commitment.get('number') + '</strong>' + ' | <span class="fs-12">' + PJQ.helpers.formatHelpers.formatCurrency(commitment.getGrandTotal()) + '</span>',
                    subtext: commitment.contractedContact?.get('companyName') ?? ''
                };
            };
            this.commitmentPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-commitment',
                valueAttribute: 'commitmentId',
                selectPickerOptions: {
                    isBlockSubtext: true,
                    size: 8,
                    choices: (model) => {
                        let costCodeId = model.get('costCodeId'),
                            vendorId = model.get('vendorId');
                        if (costCodeId > 0 || vendorId > 0) {
                            let suggested = [],
                                others = [];
                            _.each(this.projectCommitments.models, (commitment) => {
                                if (vendorId != null && commitment.contractedContact?.id !== vendorId) {
                                    return;
                                }

                                if (null != costCodeId &&
                                    null != commitment.lineItems.findWhere({costCodeId: costCodeId})) {
                                    suggested.push(commitment);
                                } else {
                                    others.push(commitment);
                                }
                            });
                            if (_.size(suggested) > 0) {
                                return [{
                                    name: 'Suggested',
                                    choices: _.map(suggested, fnCommitmentToChoice)
                                }, {
                                    name: '',
                                    choices: _.map(others, fnCommitmentToChoice)
                                }];
                            } else if (_.size(others) > 0) {
                                return _.map(others, fnCommitmentToChoice);
                            }
                        }
                        return _.map(this.projectCommitments.models, fnCommitmentToChoice);
                    }
                },
                onChange: (model, value) => {
                    let commitment = this.projectCommitments.get(value);
                    this.updateCommitmentForChangeRequestLineItem(model, commitment);

                    let row = this.dataTable.getRow(model.cid);
                    if (row) {
                        this.dataTable.refreshRow(row);
                    }

                    this.renderLineItemsTable();
                }
            });

            let fnVendorToChoice = (commitment) => {
                return {
                    id: commitment.contractedContact.id,
                    name: '<strong>' + commitment.contractedContact.get('companyName') + '</strong>',
                    subtext: commitment.contractedContact.get('contactName') ?? ''
                };
            };
            this.vendorPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-vendor',
                valueAttribute: 'vendorId',
                selectPickerOptions: {
                    // isBlockSubtext: true,
                    size: 8,
                    isIntChoices: true,
                    choices: (model) => {
                        let foundIds = [],
                            suggested = [],
                            others = [],
                            costCodeId = model.get('costCodeId') > 0;
                        _.each(this.projectCommitments.models, (commitment) => {
                            if (commitment.contractedContact == null || -1 !== foundIds.indexOf(commitment.contractedContact.id)) {
                                return;
                            }

                            foundIds.push(commitment.contractedContact.id);
                            if (costCodeId > 0 && null != commitment.lineItems.findWhere({
                                costCodeId: costCodeId
                            })) {
                                suggested.push(commitment);
                            } else {
                                others.push(commitment);
                            }
                        });
                        if (_.size(suggested) > 0) {
                            return [{
                                name: 'Suggested',
                                choices: _.map(suggested, fnVendorToChoice)
                            }, {
                                name: '',
                                choices: _.map(others, fnVendorToChoice)
                            }];
                        }
                        return _.map(others, fnVendorToChoice);
                    }
                },
                onChange: (model, value) => {
                    let commitment = null,
                        currentCommitment = this.projectCommitments.get(model.get('commitmentId')),
                        matchCommitments;
                    if (currentCommitment && currentCommitment.contractedContact && currentCommitment.contractedContact.id === value) {
                        commitment = currentCommitment
                        matchCommitments = this.projectCommitments.filter((commitment) => {
                            return commitment.contractedContact && commitment.contractedContact.id === value;
                        });
                    } else {
                        matchCommitments = this.projectCommitments.filter((commitment) => {
                            return commitment.contractedContact && commitment.contractedContact.id === value;
                        });
                    }

                    this.updateCommitmentForChangeRequestLineItem(model, commitment);

                    if (_.size(matchCommitments) > 0) {
                        let vendor = matchCommitments[0].contractedContact;
                        model.set({
                            vendorId: value,
                            vendor: vendor?.toJSON()
                        });
                        model.vendor = vendor;
                    }

                    let row = this.dataTable.getRow(model.cid);
                    if (row) {
                        this.dataTable.refreshRow(row);
                    }

                    this.renderLineItemsTable();

                    this.nextInput('vendor', model);
                }
            });
        }

        if (this.isInvoices) {
            if (this.possibleLineItems != null) {
                this.lineItemPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                    pickerSelector: '.select-line-item',
                    valueAttribute: 'lineItemId',
                    selectPickerOptions: {
                        isBlockSubtext: true,
                        size: 5,
                        choices: this.getPossibleLineItemOptions()
                    },
                    onChange: (model, value) => {
                        let selectedItem = this.possibleLineItems.get(value);
                        if (selectedItem != null) {
                            model.set(selectedItem.attributes, {
                                silent: true
                            });
                            let row = this.dataTable.getRow(model.cid);
                            this.dataTable.refreshRow(row);

                            this.nextInput('lineItem', model);
                        }
                    }
                });
            }
        } else {
            if (this.options.filterToPrimeContractItems && this.$('.select-prime-contract-item').length > 0) {
                this.fetchPrimeContract(() => {
                    this.primeContractLineItemPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                        pickerSelector: '.select-prime-contract-item',
                        valueAttribute: 'description',
                        selectPickerOptions: {
                            noneSelectedText: 'Select Item',
                            isLiveSearch: true,
                            isIntChoices: false,
                            size: 8,
                            isDisabled: (model) => {
                                return !this.options.canEdit;
                            },
                            choices: this.getPrimeContractItemChoices()
                        },
                        onChange: (model, value) => {
                            if (value === "c652db68-5944-433e-99de-17c7d26bae45") {
                                this.options.addingNewContractLineItems.push(model.cid);
                                this.dataTable.render();

                                this.toggleInput('contractItem', model);
                            } else {
                                model.set('description', value);
                                this.nextInput('pc_lineItem', model);
                            }
                        }
                    });
                });
            }

            if (_.size(this.subJobs.models) > 0) {
                this.subJobPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                    pickerSelector: '.select-sub-job',
                    valueAttribute: 'subJobId',
                    selectPickerOptions: {
                        noneSelectedText: 'Parent Job',
                        isLiveSearch: true,
                        isIntChoices: true,
                        size: 8,
                        isDisabled: _.bind(function (model) {
                            return !model.isNew() || !this.options.canEdit;
                        }, this),
                        choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                            name: 'Sub Jobs', choices: _.map(this.subJobs.models, function (subJob) {
                                return {
                                    id: subJob.id,
                                    name: subJob.get('name'),
                                    subtext: subJob.get('code')
                                }
                            }, this)
                        }])
                    },
                    onChange: _.bind(function (model, value) {
                        model.set('subJobId', value > 0 ? value : null);
                        model.set('costCodeId', 0);

                        let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid];
                        costCodePicker.render();

                        this.nextInput('subJob', model);
                    }, this)
                });
            }

            this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-cost-code',
                valueAttribute: 'costCodeId',
                selectPickerOptions: {
                    isLiveSearch: true,
                    isIntChoices: true,
                    hideDisabled: false,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew() || !this.options.canEdit;
                    }, this),
                    choices: _.bind(function (model) {
                        return this.getCostCodeOptions(model)
                    }, this)
                },
                onChange: _.bind(function (model, value) {
                    model.set('costCodeId', value);

                    let costCode = this.costCodes.get(value),
                        allowedCostTypeIds = costCode.get('costTypeIds');
                    if (_.size(allowedCostTypeIds) > 0 && allowedCostTypeIds.indexOf(model.get('costTypeId')) === -1) {
                        model.set('costTypeId', 0);
                    }

                    let costTypeSelector = this.costTypeSelectorCollection.pickers[model.cid];
                    costTypeSelector.render();

                    this.nextInput('costCode', model);
                }, this)
            });

            this.costTypeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-cost-type',
                valueAttribute: 'costTypeId',
                selectPickerOptions: {
                    isIntChoices: true,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew() || !this.options.canEdit || !(model.get('costCodeId') > 0);
                    }, this),
                    choices: _.bind(function (model) {
                        return this.getCostTypeOptions(model)
                    }, this)
                },
                onChange: _.bind(function (model, value) {
                    model.set('costTypeId', value);

                    if (typeof model.resetMarkup === 'function') {
                        model.resetMarkup();
                    }

                    if (this.options.isBudget) {
                        let hasSubJobs = _.size(this.subJobs) > 0,
                            budgetLineItem = _.find(this.budget.lineItems.models, function (li) {
                                if (hasSubJobs && li.get('subJobId') !== model.get('subJobId')) {
                                    return false;
                                } else if (li.get('accountingMethod') === PJQ.constants.budget.accountingMethod.AMOUNT && this.options.accountingMethod !== li.get('accountingMethod')) {
                                    return false;
                                }
                                return li.get('costCodeId') === model.get('costCodeId')
                                    && li.get('costTypeId') === model.get('costTypeId');
                            }, this);
                        if (budgetLineItem != null) {
                            let $line = this.getLineItemElement(model),
                                budgetedCost = budgetLineItem.get('budgetedCost'),
                                description = budgetLineItem.get('description');
                            if (this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                                let quantity = budgetLineItem.get('quantity'),
                                    unitId = budgetLineItem.get('unitId'),
                                    unitPrice = budgetLineItem.get('unitPrice');
                                model.set({
                                    description: description,
                                    quantity: quantity,
                                    unitId: unitId,
                                    unitPrice: unitPrice,
                                    budgetedCost: budgetedCost
                                });
                                $line.find('.input-quantity').val(quantity);
                                $line.find('select.select-unit-type').val(unitId > 0 ? unitId.toString() : "").change();
                                $line.find('.input-unit-price').val(PJQ.helpers.formatHelpers.formatCurrency(unitPrice));
                            } else {
                                model.set({
                                    description: budgetLineItem.get('description'),
                                    budgetedCost: budgetedCost
                                });
                                $line.find('.input-amount').val(PJQ.helpers.formatHelpers.formatCurrency(model.get('budgetedCost')));
                            }
                            $line.find('.input-description').val(model.get('description'));
                        }
                    }
                    this.nextInput('costType', model);
                }, this)
            });

            this.taxCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-tax-code',
                valueAttribute: 'taxCodeId',
                selectPickerOptions: {
                    isLiveSearch: true,
                    isIntChoices: true,
                    isDisabled: (model) => {
                        return !this.options.canEdit;
                    },
                    choices: (model) => {
                        return [{
                            id: 0,
                            name: 'N/A'
                        }, ..._.map(this.taxCodes.models, function (taxCode) {
                            return {
                                id: taxCode.id,
                                name: taxCode.get('code') + " (" + PJQ.helpers.formatHelpers.formatPercent(taxCode.get('rate') / 100) + ")"
                            }
                        }, this)];
                    }
                },
                onChange: _.bind(function (model, value) {
                    let taxCode = this.taxCodes.get(value);
                    model.set({
                        taxCodeId: taxCode ? taxCode.id : null,
                        taxRate: taxCode ? taxCode.get('rate') : 0
                    });

                    this.nextInput('taxCode', model);
                }, this)
            });

            new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-unit-type',
                valueAttribute: 'unitId',
                selectPickerOptions: {
                    isIntChoices: true,
                    isDisabled: function (model) {
                        return !model.isNew();
                    },
                    choices: _.bind(function (model) {
                        return _.map(this.unitsOfMeasure.models, function (unit) {
                            return {
                                id: unit.id,
                                name: unit.get('name')
                            }
                        });
                    }, this)
                },
                onChange: _.bind(function (model, value) {
                    model.set('unitId', value);

                    this.nextInput('unitType', model);
                }, this)
            });
        }

        if (this.options.canEdit && this.focusLineItem != null) {
            if (this.isInvoices) {
                this.toggleInput('lineItem', this.focusLineItem);
            } else if (this.options.filterToPrimeContractItems) {
                this.toggleInput('pc_lineItem', this.focusLineItem);
            } else if (_.size(this.subJobs) > 0) {
                this.toggleInput('subJob', this.focusLineItem);
            } else {
                this.toggleInput('costCode', this.focusLineItem);
            }
            this.focusLineItem = null;
        }
    },
    updateLineItemRow: function (lineItem) {
        let $line = this.getLineItemElement(lineItem),
            isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

        if (this.options.isBudget) {
            $line.find('.label-amount').text(PJQ.helpers.formatHelpers.formatCurrency(this.options.isBudget ? lineItem.get('budgetedCost') : lineItem.get('amount')));
            return;
        }

        let subTotal = lineItem.getSubTotal(this.options.financialMarkups, {
                costs: this.isChangeRequests && !this.options.showRevenue,
                isAppliedLineItem: isAppliedLineItem,
                lineItems: this.collection
            }),
            progress = lineItem.get('progressAmount');
        if (progress != null) {
            let amtRemain = subTotal - progress;
            $line.find('.label-amount-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(amtRemain));
        }

        if (this.options.financialMarkups != null) {
            _.each(this.options.financialMarkups.models, (markup) => {
                if (markup.get('void')) {
                    return;
                }

                let amt = lineItem.getMarkupAmount(this.options.financialMarkups, {
                    cid: markup.cid,
                    isAppliedLineItem: isAppliedLineItem
                });
                $line.find('.label-markup-amount-' + markup.cid.toString()).text(PJQ.helpers.formatHelpers.formatCurrency(amt));
            });
        }

        if (this.options.enableTax) {
            $line.find('.label-tax-amount').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('taxAmount')));
        }

        $line.find('.label-subtotal').text(PJQ.helpers.formatHelpers.formatCurrency(subTotal));
        $line.find('.label-amount').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('amount')));
        $line.find('.label-unit-price').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('unitPrice')));
    },
    nextInput: function (prevInput, lineItem) {
        switch (prevInput) {
            case 'pc_lineItem':
                if (this.subJobPickerCollection != null) {
                    this.toggleInput('subJob', lineItem);
                } else {
                    this.toggleInput('costCode', lineItem);
                }
                break;
            case 'subJob':
                this.toggleInput('costCode', lineItem);
                break;
            case 'costCode':
                if (lineItem.get('costCodeId') > 0 && !(lineItem.get('costTypeId') > 0)) {
                    this.toggleInput('costType', lineItem);
                }
                break;
            case 'costType':
                if (this.isChangeRequests) {
                    this.toggleInput('vendor', lineItem);
                } else {
                    this.toggleInput('description', lineItem);
                }
                break;
            case 'vendor':
                if (lineItem.get('commitmentId') == null) {
                    this.toggleInput('commitment', lineItem);
                } else {
                    this.toggleInput('description', lineItem);
                }
                break;
            case 'commitment':
                this.toggleInput('description', lineItem);
                break;
            case 'taxCode':

                break;
            case 'unitType':

                break;
        }
    },
    getPrimeContractItemChoices: function () {
        let choices = _.map(_.union(this.options.primeContract.lineItems.models, _.filter(this.collection.models, (lineItem) => {
            return _.size(lineItem.get('description')) > 0;
        })).sort((a, b) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('description') ?? "", b.get('description') ?? "");
        }), (lineItem) => {
            return {
                id: lineItem.get('description'),
                name: lineItem.get('description')
            };
        });

        choices.unshift({
            id: "c652db68-5944-433e-99de-17c7d26bae45",
            name: '<i class="fal fa-plus mr-1"></i>New Item'
        })

        return choices;
    },
    toggleInput: function (input, lineItem) {
        if (!this.options.canEdit) {
            return false;
        }

        let $line = this.getLineItemElement(lineItem);
        switch (input) {
            case 'lineItem':
                if (this.lineItemPickerCollection == null) {
                    return false;
                }

                let lineItemPicker = this.lineItemPickerCollection.getPickerForId(lineItem.cid);
                if (lineItemPicker != null) {
                    setTimeout(() => {
                        lineItemPicker.toggle();
                    }, 100);
                }
                break;
            case 'pc_lineItem':
                if (this.primeContractLineItemPickerCollection == null) {
                    return false;
                }

                let pcLineItemPicker = this.primeContractLineItemPickerCollection.getPickerForId(lineItem.cid);
                if (pcLineItemPicker != null) {
                    setTimeout(() => {
                        pcLineItemPicker.toggle();
                    }, 100);
                }
                break;
            case 'subJob':
                if (this.subJobPickerCollection == null) {
                    return false;
                }

                let subJobPicker = this.subJobPickerCollection.getPickerForId(lineItem.cid);
                if (subJobPicker != null) {
                    setTimeout(() => {
                        subJobPicker.toggle();
                    }, 100);
                }
                break;
            case 'costCode':
                if (this.costCodeSelectorCollection == null) {
                    return false;
                }

                let costCodePicker = this.costCodeSelectorCollection.getPickerForId(lineItem.cid);
                if (costCodePicker != null) {
                    setTimeout(() => {
                        costCodePicker.toggle();
                    }, 100);
                }
                break;
            case 'costType':
                if (this.costTypeSelectorCollection == null) {
                    return false;
                }

                let costTypePicker = this.costTypeSelectorCollection.getPickerForId(lineItem.cid);
                if (costTypePicker != null) {
                    setTimeout(() => {
                        costTypePicker.toggle();
                    }, 100);
                }
                break
            case 'vendor':
                if (this.vendorPickerCollection == null) {
                    return false;
                }

                let vendorPicker = this.vendorPickerCollection.getPickerForId(lineItem.cid);
                if (vendorPicker != null) {
                    setTimeout(() => {
                        vendorPicker.toggle();
                    }, 100)
                }
                break;
            case 'commitment':
                if (this.commitmentPickerCollection == null) {
                    return false;
                }

                let commitmentPicker = this.commitmentPickerCollection.getPickerForId(lineItem.cid);
                if (commitmentPicker != null) {
                    setTimeout(() => {
                        commitmentPicker.toggle();
                    }, 100)
                }
                break;
            case 'description':
                $line.find('.input-description').focus();
                break;
            case 'contractItem':
                $line.find('.input-contract-item').focus();
                break;
            case 'amount':
                $line.find('.input-amount').focus();
                break;
            case 'revenue':
                $line.find('.input-revenue').focus();
                break;
            case 'taxCode':

                break;
            case 'unitType':

                break;
        }

        return true;
    },
    addListeners: function () {
        this.stopListening(this.collection);
        this.stopListening(this.options.financialMarkups)
        if (!this.isInvoices) {
            this.listenTo(this.collection, 'change:amount change:taxRate change:costCodeId change:costTypeId', (lineItem) => {
                if (typeof lineItem.resetMarkup === 'function') {
                    lineItem.resetMarkup();
                }

                if (lineItem.get('taxRate') > 0 || lineItem.get('taxAmount') > 0) {
                    lineItem.set('taxAmount', lineItem.getTaxAmount());
                }

                this.updateLineItemRow(lineItem);

                _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                    let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                    if (lineItem) {
                        this.updateLineItemRow(lineItem);
                    }
                });

                this.renderTotals();
            });

            this.listenTo(this.collection, 'change', _.bind(function (lineItem) {
                this.updateAccountingMethodSelector();
                this.updateLineItemRow(lineItem);

                _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                    let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                    if (lineItem) {
                        this.updateLineItemRow(lineItem);
                    }
                });
            }, this));

            this.listenTo(this.collection, 'change:quantity change:unitPrice', _.bind(function (lineItem) {
                let amount = lineItem.get('unitPrice') * lineItem.get('quantity');
                if (this.options.isBudget) {
                    lineItem.set({
                        budgetedCost: amount
                    });
                } else {
                    lineItem.set({
                        amount: amount
                    });
                }
                this.updateLineItemRow(lineItem);

                _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                    let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                    if (lineItem) {
                        this.updateLineItemRow(lineItem);
                    }
                });
            }, this));

            if (this.isChangeRequests) {
                this.listenTo(this.collection, 'change:amount change:revenue', (lineItem) => {
                    let cost = lineItem.get('amount');
                    if (this.options.copyCostToRevenue && lineItem.get('costLineItemId') == null) {
                        lineItem.set({
                            revenue: cost ?? 0
                        });

                        let $line = this.getLineItemElement(lineItem);
                        $line.find('.input-revenue').val(PJQ.helpers.formatHelpers.formatCurrency(cost));
                    }

                    this.updateLineItemRow(lineItem);

                    _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                        let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                        if (lineItem) {
                            this.updateLineItemRow(lineItem);
                        }
                    });

                    this.renderTotals();
                });
            }
        } else {
            if (this.options.enableTax) {
                this.listenTo(this.collection, 'change', _.bind(function (lineItem) {
                    let $line = this.getLineItemElement(lineItem);
                    $line.find('.label-tax-amount').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('taxAmount')));
                }, this));
            }

            this.listenTo(this.collection, 'change:workRetainage change:materialRetainage change:workRetainageReleased change:materialRetainageReleased', _.bind(function (lineItem) {
                let $line = this.getLineItemElement(lineItem);
                $line.find('.label-work-retainage-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getWorkRetainageRemaining(this.model)));
                $line.find('.label-material-retainage-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getMaterialRetainageRemaining(this.model)));
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialsNew change:progressAmount', _.bind(function (lineItem) {
                let $line = this.getLineItemElement(lineItem);
                $line.find('.label-total-completed').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getTotalCompleteAndStored(this.model)));
                $line.find('.label-balance-to-finish').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getBalanceToFinish(this.model)));
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:progressAmount', _.bind(function (lineItem, id, opts) {
                if (opts && opts.percentUpdate) {
                    return;
                }

                let $line = this.getLineItemElement(lineItem),
                    amount = lineItem.get('progressAmount'),
                    stored = lineItem.get('materialsStoredTotal'),
                    nem = lineItem.get('materialsNew'),
                    committed = lineItem.get('committedAmount'),
                    totalProgress = amount + lineItem.get('progressAmountTotal');
                if (totalProgress > committed) {
                    amount = committed - lineItem.get('progressAmountTotal') - stored - nem;
                    lineItem.set('progressAmount', amount);

                    totalProgress = amount + lineItem.get('progressAmountTotal');

                    $line.find('.input-progress-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                }

                let percent = (totalProgress / (committed - stored - nem)) * 100;
                percent = Math.round(percent * 100) / 100;

                $line.find('.input-progress-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set('progressPercent', percent, {
                    silent: true
                });

                if (lineItem.get('taxRate') > 0 || lineItem.get('taxAmount') > 0) {
                    lineItem.set('taxAmount', lineItem.getTaxAmount());
                }

                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:progressPercent change:materialsNew', _.bind(function (lineItem) {
                let percent = lineItem.get('progressPercent'),
                    // totalProgressPercent = lineItem.get('progressPercentTotal'),
                    $line = this.getLineItemElement(lineItem);

                if (percent > 100) {
                    percent = 100;
                    lineItem.set('progressPercent', percent);
                    $line.find('.input-progress-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                }

                let committed = lineItem.get('committedAmount'),
                    totalProgress = lineItem.get('progressAmountTotal'),
                    stored = lineItem.get('materialsStoredTotal'),
                    nem = lineItem.get('materialsNew'),
                    amount = Math.round(((committed - stored - nem) * (percent / 100)) - totalProgress);

                let billableNow = committed - stored - nem - totalProgress;
                if ((billableNow < 0 && amount < billableNow) || (billableNow > 0 && amount > billableNow)) {
                    amount = 0;
                }

                if (lineItem.get('taxRate') > 0 || lineItem.get('taxAmount') > 0) {
                    lineItem.set('taxAmount', lineItem.getTaxAmount());
                }

                $line.find('.input-progress-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    progressAmount: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialsNew', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let stored = lineItem.get('materialsStoredTotal'),
                    nem = lineItem.get('materialsNew'),
                    percent = lineItem.get('materialRetainagePercent'),
                    materialRetainage = (stored + nem) * (percent / 100);


                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-amount').val(materialRetainage / 100);
                lineItem.set({
                    materialRetainage: materialRetainage
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainage', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('workRetainage'),
                    percent = (amount / lineItem.get('progressAmount')) * 100;
                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    workRetainagePercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainagePercent change:progressAmount', _.bind(function (lineItem) {
                let percent = lineItem.get('workRetainagePercent'),
                    amount = Math.round(lineItem.get('progressAmount') * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    workRetainage: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainage', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('materialRetainage'),
                    percent = (amount / lineItem.get('materialsNew')) * 100;
                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    materialRetainagePercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainagePercent', _.bind(function (lineItem) {
                let percent = lineItem.get('materialRetainagePercent'),
                    amount = Math.round(lineItem.get('materialsNew') * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    materialRetainage: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainageReleased', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('workRetainageReleased'),
                    retainage = lineItem.getWorkRetainageTotal(),
                    percent = (amount / retainage) * 100;
                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-released-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    workRetainageReleasedPercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainageReleasedPercent change:workRetainage', _.bind(function (lineItem) {
                let percent = lineItem.get('workRetainageReleasedPercent'),
                    retainage = lineItem.getWorkRetainageTotal(),
                    amount = Math.round(retainage * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-released-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    workRetainageReleased: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainageReleased', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('materialRetainageReleased'),
                    retainage = lineItem.getMaterialRetainageTotal(),
                    percent = (amount / retainage) * 100;

                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-released-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    materialRetainageReleasedPercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainageReleasedPercent change:materialRetainage', _.bind(function (lineItem) {
                let percent = lineItem.get('materialRetainageReleasedPercent'),
                    retainage = lineItem.getMaterialRetainageTotal(),
                    amount = Math.round(retainage * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-released-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    materialRetainageReleased: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));
        }

        if (this.options.financialMarkups) {
            this.listenTo(this.options.financialMarkups, 'appliedMarkupChanged', (markup) => {
                if (!markup.get('void') && !markup.get('lineItemId') && !markup.lineItem) {
                    markup.lineItem = new this.collection.model({
                        costCodeId: markup.get('appliedCostCodeId'),
                        costTypeId: markup.get('appliedCostTypeId'),
                        description: markup.get('name'),
                        quantity: 1,
                        unitPrice: 0
                    });
                    markup.lineItem.markup = markup;

                    this.collection.add(markup.lineItem);
                    this.renderLineItemsTable();
                    if (typeof this.options.onLineItemAdd === 'function') {
                        this.options.onLineItemAdd(markup.lineItem);
                    }
                    this.updateLineItemRow(markup.lineItem);
                } else {
                    let lineItem = markup.lineItem;
                    if (lineItem == null) {
                        lineItem = this.collection.get(markup.get('lineItemId'));
                    }
                    console.log(lineItem);

                    if (markup.get('void')) {
                        let row = this.dataTable.getRow(lineItem.cid);
                        if (row) {
                            this.dataTable.removeRow(row);
                        }
                        this.collection.remove(lineItem);
                        this.renderTotals();
                    } else {
                        this.updateLineItemRow(lineItem);
                    }
                }
            });
        }
    },
    getPossibleLineItems: function () {
        let result = [];
        _.each(this.possibleLineItems.models, function (pLineItem) {
            let exists = null != _.find(this.model.lineItems.models, function (li) {
                return !li.get('delete') && li.get('lineItemId') === pLineItem.get('lineItemId')
                    && (li.get('commitmentId') === pLineItem.get('commitmentId')
                        || li.get('changeOrderId') === pLineItem.get('changeOrderId'));
            });
            if (!exists) {
                result.push(pLineItem);
            }
        }, this);
        return result;
    },
    getPossibleLineItemOptions: function () {
        let contractNumber = '',
            contractLines = [],
            changes = {};
        _.each(this.getPossibleLineItems(), function (pLineItem) {
            let costCode = this.costCodes.get(pLineItem.get('costCodeId')),
                costType = this.costTypes.get(pLineItem.get('costTypeId'));
            if (costCode != null && costType != null) {
                let choice = {
                    id: pLineItem.cid,
                    name: '<b>' + costCode.getDisplayName() + '</b>' + ' - ' + costType.get('name'),
                    subtext: PJQ.helpers.formatHelpers.formatCurrency(pLineItem.get('committedAmount'))
                };
                let changeOrderId = pLineItem.get('changeOrderId');
                if (changeOrderId > 0) {
                    if (changes[changeOrderId] == null) {
                        changes[changeOrderId] = {
                            name: pLineItem.get('changeOrderNumber'),
                            choices: []
                        };
                    }
                    changes[changeOrderId].choices.push(choice);
                } else {
                    contractNumber = _.size(pLineItem.get('commitmentNumber')) > 0 ? pLineItem.get('commitmentNumber') : pLineItem.get('primeContractNumber');
                    contractLines.push(choice);
                }
            }
        }, this);
        return [
            {
                name: contractNumber ?? "",
                choices: contractLines
            },
            ..._.map(changes, (obj) => {
                return obj;
            })
        ];
    },
    getCostCodeOptions: function (model) {
        let subJob = this.subJobs.get(model.get('subJobId')),
            budgeted = [],
            unBudgeted = [],
            filteredCostCodes = _.filter(this.costCodes.models, function (costCode) {
                if (subJob == null) {
                    return costCode.get('subJobId') == null
                }
                return costCode.get('subJobId') === subJob.id;
            });

        if (this.options.filterToCommitmentCostCodes && this.options.commitment != null) {
            filteredCostCodes = _.filter(filteredCostCodes, (costCode) => {
                return null != this.options.commitment.lineItems.findWhere({costCodeId: costCode.id});
            });
        }

        if (_.size(filteredCostCodes) === 0) {
            return [{
                id: 0,
                name: 'No cost codes found',
                disabled: true
            }];
        }

        _.each(filteredCostCodes.sort((c1, c2) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
        }), function (costCode) {
            let choice = {
                id: costCode.id,
                name: costCode.getDisplayName()
            };
            if (this.budget != null && null == _.find(this.budget.lineItems.models, function (lineItem) {
                return !lineItem.get('isUnBudgeted') && lineItem.get('costCodeId') === costCode.id
                    && ((subJob == null && !(lineItem.get('subJobId') > 0)) || lineItem.get('subJobId') === subJob.id);
            })) {
                unBudgeted.push(choice);
            } else {
                budgeted.push(choice);
            }
        }, this);
        return [
            {
                name: "Budgeted",
                choices: budgeted
            },
            {
                name: "Un-Budgeted",
                choices: unBudgeted
            }
        ];
    },
    getCostTypeOptions: function (model) {
        let costCode = this.costCodes.get(model.get('costCodeId'));
        if (costCode == null) {
            return [];
        }

        let budgeted = [],
            unBudgeted = [],
            allowedCostTypes = costCode.get('costTypeIds'),
            filteredCostTypes = _.filter(this.costTypes.models, function (costType) {
                return (_.size(allowedCostTypes) === 0 || allowedCostTypes.indexOf(costType.id) !== -1);
            });

        if (this.options.filterToCommitmentCostCodes && this.options.commitment != null) {
            filteredCostTypes = _.filter(this.costTypes.models, (costType) => {
                return null != this.options.commitment.lineItems.findWhere({costTypeId: costType.id});
            });
        }

        if (this.options.project
            && PJQ.app.session.erpIntegration
            && PJQ.app.session.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.REQUIRE_SYNCED_COST_TYPES)) {
            let filterUnsyncedCostTypes = _.bind(function () {
                if (this.options.project.get('externalObject') != null) {
                    filteredCostTypes = _.filter(filteredCostTypes, (costType) => {
                        return costType.get('externalObject') != null;
                    })
                }
            }, this)

            if (!this.options.project.erpObjectFetched) {
                this.options.project.fetchERPObject(filterUnsyncedCostTypes());
            } else {
                filterUnsyncedCostTypes();
            }
        }

        if (this.budget == null) {
            return _.map(filteredCostTypes, (costType) => {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            });
        }

        _.each(filteredCostTypes, function (costType) {
            let choice = {
                id: costType.id,
                name: costType.get('name')
            };
            if (null == _.find(this.budget.lineItems.models, function (lineItem) {
                return !lineItem.get('isUnBudgeted') && lineItem.get('costCodeId') === costCode.id
                    && lineItem.get('costTypeId') === costType.id;
            })) {
                unBudgeted.push(choice);
            } else {
                budgeted.push(choice);
            }
        }, this);
        return [
            {
                name: "Budgeted",
                choices: budgeted
            },
            {
                name: "Un-Budgeted",
                choices: unBudgeted
            }
        ];
    },
    getLineItemForInput: function ($input) {
        if ($input == null || this.dataTable == null) {
            return null;
        }
        let row = this.dataTable.getRow($input.closest('tr'));
        if (row) {
            return row.data();
        }
        return null;
    },
    getLineItemRow: function (lineItem) {
        if (lineItem == null || this.dataTable == null) {
            return null;
        }
        return this.dataTable.getRow(lineItem.cid);
    },
    getLineItemElement: function (lineItem) {
        let row = this.getLineItemRow(lineItem);
        if (row) {
            return $(row.node());
        }
        return null;
    },
    addLineItem: function (e) {
        let newLineItem = new this.options.lineItemModel({
            description: '',
            quantity: 0,
            unitPrice: 0,
            amount: 0,
            taxAmount: 0,
            budgetedHours: 0,
            taxRate: 0,
            amountRemaining: 0,
            billedToDate: 0,
            accountingMethod: this.options.accountingMethod
        });

        let fnAdd = () => {
            this.focusLineItem = newLineItem;
            this.collection.add(newLineItem);
            this.renderLineItemsTable();
            if (typeof this.options.onLineItemAdd === 'function') {
                this.options.onLineItemAdd(newLineItem);
            }
        }
        if (this.isInvoices) {
            this.model.fetchPossibleLineItems(_.bind(function (pLineItems) {
                this.possibleLineItems = pLineItems;

                if (_.size(this.getPossibleLineItems()) === 0) {
                    new PJQ.Alert(this.$('.line-items-table'), {
                        type: 'warning',
                        text: 'All line items from the related commitment and change orders are already added',
                        timeout: 3000,
                        extraClasses: ['mt-2'],
                        isPrepend: true
                    });
                    this.$('.btn-grp-add-line-item').prop('disabled', true);
                } else {
                    fnAdd();
                }
            }, this));
        } else if (this.options.filterToCommitmentCostCodes && (this.options.commitment != null || this.options.commitmentId > 0)) {
            if (this.options.commitment == null) {
                this.options.commitment = new PJQ.models.commitments.Commitment({
                    id: this.options.commitmentId
                });
            }

            if (!this.options.commitment.isFetched) {
                this.options.commitment.fetch({
                    success: _.bind(function () {
                        fnAdd();
                    }, this)
                });
            } else {
                fnAdd();
            }
        } else if (this.options.filterToPrimeContractItems && (this.options.primeContract != null || this.options.primeContractId > 0)) {
            this.fetchPrimeContract(fnAdd);
        } else {
            fnAdd();
        }
    },
    fetchPrimeContract: function (callback) {
        if (this.options.primeContract == null) {
            this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: this.options.primeContractId
            });
        }

        if (!this.options.primeContract.isFetched) {
            this.options.primeContract.fetch({
                success: () => {
                    callback();
                }
            });
        } else {
            callback();
        }
    },
    addFromChangeRequests: function () {
        new PJQ.views.changeRequests.SelectChangeRequestsModal({
            isSingleChoice: false,
            project: this.options.project,
            primeContractId: this.options.primeContractId,
            headerSubText: 'Select the Change Requests you would like to add line items from.',
            filterStatuses: PJQ.constants.changeRequests.changeRequestStatus.APPROVED,
            onSave: _.bind(function (changeRequests) {
                let changeRequestIds = _.map(changeRequests, function (model) {
                    return model.id;
                }, this);

                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'changerequests'
                        },
                        {
                            endpoint: 'lineitems'
                        }
                    ]),
                    data: changeRequestIds,
                    isAPIv2: true
                }).post().done((lineItems) => {
                    let availableLineItems = _.filter(lineItems, function (lineItem) {
                        if (null != this.collection.findWhere((li) => {
                            return li.get('changeRequestLineItemId') === lineItem.id;
                        })) {
                            return false;
                        } else if (this.isCCO || this.isCommitments) {
                            return lineItem.costLineItemId == null
                        } else {
                            return lineItem.revenueLineItemId == null;
                        }
                    }, this);

                    if (_.size(availableLineItems) > 0) {
                        _.each(availableLineItems, function (lineItem) {
                            let lineItemModel = new this.options.lineItemModel({
                                changeRequestLineItemId: lineItem.id,
                                amount: lineItem.amount,
                                markupAmount: lineItem.markupAmount,
                                taxAmount: lineItem.taxAmount,
                                number: lineItem.number,
                                costCodeId: lineItem.costCodeId,
                                costTypeId: lineItem.costTypeId,
                                subJobId: lineItem.subJobId,
                                description: lineItem.description,
                                unitId: lineItem.unitId,
                                quantity: lineItem.quantity,
                                unitPrice: lineItem.unitPrice,
                                progressQuantity: lineItem.progressQuantity,
                                progressPercent: lineItem.progressPercent,
                                progressAmount: lineItem.progressAmount,
                                workRetainage: lineItem.workRetainage,
                                workRetainageReleased: lineItem.workRetainageReleased,
                                materialRetainage: lineItem.materialRetainage,
                                materialRetainageReleased: lineItem.materialRetainageReleased,
                                taxCodeId: lineItem.taxCodeId
                            });
                            this.collection.add(lineItemModel);

                            if (typeof this.options.onLineItemAdd === 'function') {
                                this.options.onLineItemAdd(lineItemModel);
                            }
                        }, this);

                        this.renderLineItemsTable();
                        this.renderTotals();
                    } else {
                        new PJQ.Alert(this.$('.line-items-table'), {
                            type: 'warning',
                            text: 'All line items from the selected Change Requests have already been assigned',
                            timeout: 5000,
                            extraClasses: ['mt-2'],
                            isPrepend: true
                        });
                    }
                });
            }, this)
        });
    },
    addFromCommitments: function () {
        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: false,
            project: this.options.project,
            headerSubText: 'Select the Commitments you would like to add line items from.',
            filterStatuses: PJQ.constants.commitments.commitmentStatus.APPROVED,
            onSave: (commitments) => {
                let commitmentIds = _.map(commitments, function (model) {
                    return model.id;
                }, this);

                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'commitments'
                        },
                        {
                            endpoint: 'lineitems'
                        }
                    ]),
                    data: commitmentIds,
                    isAPIv2: true
                }).post().done(_.bind(function (lineItems) {
                    let availableLineItems = _.filter(lineItems, function (lineItem) {
                        return lineItem.changeRequestLineItemId == null;
                    }, this);

                    if (_.size(availableLineItems) > 0) {
                        _.each(availableLineItems, function (lineItem) {
                            let lineItemModel = new this.options.lineItemModel({
                                commitmentId: lineItem.commitmentId,
                                amount: lineItem.amount,
                                number: lineItem.number,
                                costCodeId: lineItem.costCodeId,
                                costTypeId: lineItem.costTypeId,
                                subJobId: lineItem.subJobId,
                                description: lineItem.description,
                                unitId: lineItem.unitId,
                                quantity: lineItem.quantity,
                                unitPrice: lineItem.unitPrice,
                                markup: lineItem.markup,
                                progressQuantity: lineItem.progressQuantity,
                                progressPercent: lineItem.progressPercent,
                                progressAmount: lineItem.progressAmount,
                                workRetainage: lineItem.workRetainage,
                                workRetainageReleased: lineItem.workRetainageReleased,
                                materialRetainage: lineItem.materialRetainage,
                                materialRetainageReleased: lineItem.materialRetainageReleased,
                                taxCodeId: lineItem.taxCodeId
                            });
                            this.collection.add(lineItemModel);

                            if (typeof this.options.onLineItemAdd === 'function') {
                                this.options.onLineItemAdd(lineItemModel);
                            }
                        }, this);

                        this.renderLineItemsTable();
                        this.renderTotals();
                    } else {
                        new PJQ.Alert(this.$('.line-items-table'), {
                            type: 'warning',
                            text: 'All line items from the selected Commitment have already been assigned',
                            timeout: 5000,
                            extraClasses: ['mt-2'],
                            isPrepend: true
                        });
                    }
                }, this));
            }
        });
    },
    addAllPossibleLineItems: function () {
        this.model.fetchPossibleLineItems(_.bind(function (pLineItems) {
            this.possibleLineItems = pLineItems;
            let changed = false,
                newLineItems = [];
            _.each(this.possibleLineItems.models, function (pLineItem) {
                let existingLineItem = _.find(this.model.lineItems.models, function (li) {
                    return li.get('lineItemId') === pLineItem.get('lineItemId')
                        && ((li.get('commitmentId') === pLineItem.get('commitmentId'))
                            || (li.get('changeOrderId') === pLineItem.get('changeOrderId')))
                });
                if (existingLineItem) {
                    if (existingLineItem.get('delete')) {
                        existingLineItem.set('delete', false);
                        changed = true;
                    }
                } else {
                    newLineItems.push(pLineItem);
                    changed = true;
                }
            }, this)
            if (changed) {
                if (_.size(newLineItems) > 0) {
                    this.collection.add(newLineItems);
                }
                this.renderLineItemsTable();
            }
        }, this));
    },
    autofillAmounts: function () {
        if (typeof this.model.getAutofillAmounts === 'function') {
            this.model.getAutofillAmounts((lineItems) => {
                if (lineItems != null && _.size(lineItems.models) > 0) {
                    _.each(lineItems.models, function (autoFillItem) {
                        let invoiceItem = _.find(this.collection.models, function (li) {
                            return li.get('costCodeId') === autoFillItem.get('costCodeId')
                                && li.get('costTypeId') === autoFillItem.get('costTypeId');
                        });
                        if (invoiceItem != null) {
                            invoiceItem.set({
                                progressAmount: autoFillItem.get('progressAmount'),
                                progressPercent: autoFillItem.get('progressPercent'),
                                materialsNew: autoFillItem.get('materialsNew'),
                                workRetainage: autoFillItem.get('workRetainage'),
                                workRetainagePercent: autoFillItem.get('workRetainagePercent'),
                                materialRetainage: autoFillItem.get('materialRetainage'),
                                materialRetainagePercent: autoFillItem.get('materialRetainagePercent')
                            })
                        } else {
                            this.collection.add(autoFillItem);
                        }
                    }, this);
                    this.renderLineItemsTable();

                    PJQ.notifications.notify.successNotify({
                        message: 'Line items auto-filled successfully'
                    });
                } else {
                    PJQ.notifications.notify.warningNotify({
                        message: 'Found 0 line items to auto-fill'
                    });
                }
            });
        }
    },
    validateLineItem: function (lineItem) {
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(lineItem.cid),
            data = row.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null || data.get('delete')) {
            return true;
        }

        if (row != null) {
            if (!this.isInvoices) {
                let costCodeCol = 1,
                    costTypeCol = 2,
                    uomCol = 5;
                if (_.size(this.subJobs) > 0) {
                    costCodeCol++;
                    costTypeCol++;
                    uomCol++;
                }

                let contractItemCol = null;
                if (this.options.filterToPrimeContractItems) {
                    costCodeCol++;
                    costTypeCol++;
                    uomCol++;

                    contractItemCol = this.options.enableSelection ? 2 : 1;
                }

                if (this.options.requirePrimeContractItem && contractItemCol != null) {
                    updateCell($(row.nodes()[0]).find('td:eq(' + contractItemCol + ')'), _.size(lineItem.get('description')) > 0);
                }

                if (this.options.isCostCodeRequired !== false) {
                    updateCell($(row.nodes()[0]).find('td:eq(' + costCodeCol + ')'), lineItem.get('costCodeId') > 0);
                }

                if (this.options.isCostTypeRequired !== false) {
                    updateCell($(row.nodes()[0]).find('td:eq(' + costTypeCol + ')'), lineItem.get('costTypeId') > 0);
                }

                if (this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                    updateCell($(row.nodes()[0]).find('td:eq(' + uomCol + ')'), lineItem.get('unitId') > 0 || lineItem.markup || lineItem.get('appliedMarkupId') > 0);
                }
            } else {

            }
        }
        return result;
    },
    validate: function () {
        this.wasValidated = true;

        let result = true;
        _.each(this.collection.models, function (lineItem) {
            result = result && this.validateLineItem(lineItem);
        }, this);
        return result;
    },
    saveLineItem: function (e) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
    },
    deleteLineItem: function (row) {
        if (row == null) {
            return;
        }

        let item = row.data();
        if (this.collection != null) {
            if (item.isNew()) {
                this.collection.remove(item);
            } else {
                item.set('delete', true);
            }
            this.dataTable.removeRow(row);
            this.renderTotals();
            this.$('.btn-grp-add-line-item').prop('disabled', false);
        }

        if (typeof this.options.onLineItemDelete === 'function') {
            this.options.onLineItemDelete(item);
        }
    },
    deleteLineItemClicked: function (e) {
        e.stopPropagation();
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        if (row != null) {
            let item = row.data();
            if (item && item.get('changeRequestLineItemId') && !item.isNew()) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "This line item was created from a Change Request. This line item will still exist on the Change Request, but it will no longer be assigned. Are you sure you want to delete this line item?",
                    onDelete: _.bind(function () {
                        this.deleteLineItem(row);
                    }, this)
                });
            } else {
                this.deleteLineItem(row);
            }
        }
    },
    bulkDeleteLineItems: function () {
        let lineItems = _.map(this.options.selectedLineItems, (cid) => {
            return this.collection.get(cid);
        });
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "You're about to delete " + _.size(lineItems) + " line items. Are you sure you want to delete these line items?",
            onDelete: _.bind(function () {
                _.each(lineItems, (lineItem) => {
                    this.deleteLineItem(this.getLineItemRow(lineItem));
                })
            }, this)
        });
    },
    bulkEditLineItems: function () {
        let lineItems = _.map(this.options.selectedLineItems, (cid) => {
            return this.collection.get(cid);
        });

        new PJQ.views.budget.BulkEditLineItemsModal({
            lineItems: lineItems,
            enableRetainage: this.options.enableRetainage,
            enableStoredMaterials: this.options.enableStoredMaterials,
            onSave: () => {
                this.options.selectedLineItems = [];
                this.renderActions();
                this.renderLineItemsTable();
                this.renderTotals();
            }
        })
    },
    viewCommitment: function (e) {
        let id = $(e.currentTarget).data('id');
        if (typeof this.options.onCommitmentView === 'function') {
            this.options.onCommitmentView(id);
        }
        if (id > 0) {
            new PJQ.views.commitments.CommitmentEditModal({
                model: new PJQ.models.commitments.Commitment({
                    id: id
                })
            });
        }
    },
    viewChangeOrder: function (e) {
        let id = $(e.currentTarget).data('id'),
            type = $(e.currentTarget).data('type');
        if (typeof this.options.onChangeOrderView === 'function') {
            this.options.onChangeOrderView(id);
        }

        if (id > 0 && _.size(type) > 0) {
            if (this.isReceivableInvoices || type === 'pcco') {
                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: new PJQ.models.primeContracts.ChangeOrder({
                        id: id
                    })
                });
            } else {
                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: new PJQ.models.commitments.ChangeOrder({
                        id: id
                    })
                });
            }
        }
    },
    lineItemSelected: function (e) {
        if (this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            isChecked = $target.prop('checked');
        if (_.size(cid) > 0) {
            if (isChecked) {
                this.options.selectedLineItems.push(cid);
            } else {
                this.options.selectedLineItems = _.reject(this.options.selectedLineItems, function (sCid) {
                    return sCid === cid;
                });
            }
        }

        this.$('.select-all-line-items').prop('checked', _.size(this.options.selectedLineItems) === _.size(this.collection.models));

        this.renderActions();
    },
    selectAllLineItems: function (e) {
        let $target = $(e.currentTarget),
            isChecked = $target.prop('checked');

        if (!isChecked || this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        _.each(this.collection.models, function (model) {
            if (model.markup || model.get('appliedMarkupId') > 0) {
                return;
            }

            let checkbox = this.$('.select-cr-li[data-cid="' + model.cid + '"]');

            if (!isChecked) {
                checkbox.prop('checked', false);
            } else {
                checkbox.prop('checked', true);

                if (!_.contains(this.options.selectedLineItems, model.cid)) {
                    this.options.selectedLineItems.push(model.cid);
                }
            }
        }, this);

        this.renderActions();
    },
    renderActions: function () {
        let disableCommitmentsButtons = true,
            disableContractsButtons = true;
        if (_.size(this.options.selectedLineItems) > 0) {
            this.$('.btn-create-new').removeClass('disabled');

            _.each(this.collection.get(this.options.selectedLineItems), (lineItem) => {
                if (!(lineItem.get('costLineItemId') > 0)) {
                    disableCommitmentsButtons = false;
                }

                if (!(lineItem.get('revenueLineItemId') > 0)) {
                    disableContractsButtons = false;
                }
            });
        }
        this.renderSubTemplate(false, this.options.subTemplates.actions, this.$('.line-items-actions'), _.extend(this.renderData(), {
            disableCommitmentsButtons: disableCommitmentsButtons,
            disableContractsButtons: disableContractsButtons
        }), () => {
            if (this.accountingMethodPicker) {
                this.accountingMethodPicker.remove();
            }
            this.accountingMethodPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-accounting-method'),
                isIntChoices: true,
                defaultValue: this.options.accountingMethod,
                canEdit: this.options.canEdit && _.size(this.getVisibleLineItems()) === 0,
                onChange: _.bind(function (value) {
                    this.options.accountingMethod = value;
                    if (typeof this.options.onAccountingMethodChanged === 'function') {
                        this.options.onAccountingMethodChanged(value);
                    }
                    this.renderLineItemsTable();
                }, this)
            });
        });
    },
    addLineItemsToCommitment: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            headerSubText: 'Select the Commitment you would like to add these line items to',
            filterStatuses: [
                PJQ.constants.commitments.commitmentStatus.DRAFT,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING,
                PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID,
                PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE,
                PJQ.constants.commitments.commitmentStatus.SUBMITTED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PARTIALLY_RECEIVED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_RECEIVED
            ],
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems);
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        commitment.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            commitmentId: commitment.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.CommitmentEditModal({
                    model: commitment,
                    fetch: false,
                    onSave: _.bind(function (commitment) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    createCommitmentFromLineItems: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentType = $(e.currentTarget).hasClass('new-po') ? PJQ.constants.commitments.commitmentType.PURCHASE_ORDER : PJQ.constants.commitments.commitmentType.SUBCONTRACT,
            lineItems = [],
            selLineItems = this.collection.get(this.options.selectedLineItems),
            vendors = [],
            vendorIds = [];
        _.each(selLineItems, function (lineItem) {
            if (lineItem.get('costLineItemId') == null) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    changeRequestLineItemId: lineItem.id
                }));

                let liVendor = lineItem.get('vendor');
                if (vendors == null) {
                    return;
                } else if (liVendor && vendorIds.indexOf(liVendor.id) === -1) {
                    vendors.length > 0 ? null : vendors.push(liVendor);
                }
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.commitments.CommitmentEditModal({
                model: null,
                fromChangeRequest: this.model,
                contractedContact: vendors.length > 0 ? vendors[0] : null,
                commitmentType: commitmentType,
                lineItems: lineItems,
                onSave: _.bind(function (commitment) {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                }, this),
            });
        }
    },
    addLineItemsToPCCO: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.primeContracts.SelectChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Contract Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                PJQ.constants.primeContracts.changeOrderStatus.NO_CHARGE,
                PJQ.constants.primeContracts.changeOrderStatus.IN_REVIEW,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems);
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('revenueLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    createPCCOFromLineItems: async function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let primeContract = new PJQ.models.primeContracts.PrimeContract({
            id: this.options.changeRequest.get('primeContractId')
        });
        await primeContract.fetch();

        let lineItems = [],
            selLineItems = this.collection.get(this.options.selectedLineItems);
        _.each(selLineItems, function (lineItem) {
            if (!lineItem.get('revenueLineItemId')) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    amount: lineItem.get('revenue'),
                    changeRequestLineItemId: lineItem.id
                }));
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.primeContracts.ChangeOrderEditModal({
                primeContract: primeContract,
                lineItems: lineItems,
                onSave: _.bind(function (commitment) {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                }, this),
            });
        }
    },
    addLineItemsToCCO: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.commitments.SelectCommitmentChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Commitment Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.commitments.changeOrderStatus.DRAFT,
                PJQ.constants.commitments.changeOrderStatus.NO_CHARGE,
                PJQ.constants.commitments.changeOrderStatus.IN_REVIEW,
                PJQ.constants.commitments.changeOrderStatus.NOT_PRICING,
                PJQ.constants.commitments.changeOrderStatus.PRICING,
                PJQ.constants.commitments.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems);
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    getSelectedCommitmentIds: function () {
        let commitmentIds = _.uniq(_.map(this.options.selectedLineItems, (liCid) => {
            let lineItem = this.collection.get(liCid);
            return lineItem.get('commitmentId');
        }));
        return commitmentIds;
    },
    createCCOFromLineItems: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            filterStatuses: PJQ.constants.commitments.commitmentStatus.APPROVED,
            headerSubText: 'Select the Commitment you would like to create a Change Order for.',
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems),
                    lineItems = [];
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        lineItems.push(_.extend(lineItem.attributes, {
                            id: null,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                if (_.size(lineItems) > 0) {
                    new PJQ.views.commitments.ChangeOrderEditModal({
                        commitment: commitment,
                        fromChangeRequest: this.model,
                        lineItems: lineItems,
                        onSave: _.bind(function (changeOrder) {
                            if (typeof this.options.onCreateFromLineItems === 'function') {
                                this.options.onCreateFromLineItems();
                            }
                        }, this),
                    });
                }
            }
        });
    }
});